var items = {
  "block.minecraft.acacia_button": "Agazienhulzgnopp",
  "block.minecraft.acacia_door": "Agazienhulzdiere",
  "block.minecraft.acacia_fence": "Agazienhulzzaun",
  "block.minecraft.acacia_fence_gate": "Agazienhulzzaundorr",
  "block.minecraft.acacia_hanging_sign": "Agazienhulzhängeschüld",
  "block.minecraft.acacia_leaves": "Agazienlaub",
  "block.minecraft.acacia_log": "Agazienschdamm",
  "block.minecraft.acacia_planks": "Agazienhulzbreddorr",
  "block.minecraft.acacia_pressure_plate": "Agazienhulzdruggbladde",
  "block.minecraft.acacia_sapling": "Agazienseddsling",
  "block.minecraft.acacia_shelf": "Akazienholzregal",
  "block.minecraft.acacia_sign": "Agazienhulzschüld",
  "block.minecraft.acacia_slab": "Agazienhulzschdufe",
  "block.minecraft.acacia_stairs": "Agazienhulzdrebbe",
  "block.minecraft.acacia_trapdoor": "Agazienhulzfalldiere",
  "block.minecraft.acacia_wall_hanging_sign": "Agazienhulzwandhängeschüld",
  "block.minecraft.acacia_wall_sign": "Agazienhulzwandschüld",
  "block.minecraft.acacia_wood": "Agazienhulz",
  "block.minecraft.activator_rail": "Aggdivierungsschiene",
  "block.minecraft.air": "Lufd",
  "block.minecraft.allium": "Schdernlauch",
  "block.minecraft.amethyst_block": "Amethystdrusnblogg",
  "block.minecraft.amethyst_cluster": "Amethysthaufn",
  "block.minecraft.ancient_debris": "Andigorr Schrodd",
  "block.minecraft.andesite": "Andesid",
  "block.minecraft.andesite_slab": "Andesidschdufe",
  "block.minecraft.andesite_stairs": "Andesiddrebbe",
  "block.minecraft.andesite_wall": "Andesidmauor",
  "block.minecraft.anvil": "Ambuss",
  "block.minecraft.attached_melon_stem": "Melonrange",
  "block.minecraft.attached_pumpkin_stem": "Gürbisschdängl",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlaub",
  "block.minecraft.azure_bluet": "Porzellanschdernschn",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblogg",
  "block.minecraft.bamboo_button": "Bambusgnopp",
  "block.minecraft.bamboo_door": "Bambusdiere",
  "block.minecraft.bamboo_fence": "Bambuszaun",
  "block.minecraft.bamboo_fence_gate": "Bambuszaundorr",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschüld",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikplatte",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktreppe",
  "block.minecraft.bamboo_planks": "Bambusbreddorr",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplatte",
  "block.minecraft.bamboo_sapling": "Bambusschbrössling",
  "block.minecraft.bamboo_shelf": "Bambusregal",
  "block.minecraft.bamboo_sign": "Bambusschüld",
  "block.minecraft.bamboo_slab": "Bambusschdufe",
  "block.minecraft.bamboo_stairs": "Bambusdrebbe",
  "block.minecraft.bamboo_trapdoor": "Bambusfalldiere",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschüld",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschüld",
  "block.minecraft.banner.base.black": "Ledsche schworze Fläsche",
  "block.minecraft.banner.base.blue": "Ledsche blaue Fläsche",
  "block.minecraft.banner.base.brown": "Ledsche braune Fläsche",
  "block.minecraft.banner.base.cyan": "Ledsche dürgise Fläsche",
  "block.minecraft.banner.base.gray": "Ledsche graue Fläsche",
  "block.minecraft.banner.base.green": "Ledsche griene Fläsche",
  "block.minecraft.banner.base.light_blue": "Ledsche hellblaue Fläsche",
  "block.minecraft.banner.base.light_gray": "Ledsche hellgraue Fläsche",
  "block.minecraft.banner.base.lime": "Ledsche hellgriene Fläsche",
  "block.minecraft.banner.base.magenta": "Ledsche magenda Fläsche",
  "block.minecraft.banner.base.orange": "Ledsche orangsche Fläsche",
  "block.minecraft.banner.base.pink": "Ledsche pinge Fläsche",
  "block.minecraft.banner.base.purple": "Ledsche lila Fläsche",
  "block.minecraft.banner.base.red": "Ledsche rode Fläsche",
  "block.minecraft.banner.base.white": "Ledsche weeße Fläsche",
  "block.minecraft.banner.base.yellow": "Ledsche gelbe Fläsche",
  "block.minecraft.banner.border.black": "Schworzorr Bord",
  "block.minecraft.banner.border.blue": "Blauorr Bord",
  "block.minecraft.banner.border.brown": "Braunorr Bord",
  "block.minecraft.banner.border.cyan": "Dürgisorr Bord",
  "block.minecraft.banner.border.gray": "Grauorr Bord",
  "block.minecraft.banner.border.green": "Grienorr Bord",
  "block.minecraft.banner.border.light_blue": "Hellblauorr Bord",
  "block.minecraft.banner.border.light_gray": "Hellgrauorr Bord",
  "block.minecraft.banner.border.lime": "Hellgrienorr Bord",
  "block.minecraft.banner.border.magenta": "Magenda Bord",
  "block.minecraft.banner.border.orange": "Orangschorr Bord",
  "block.minecraft.banner.border.pink": "Pingorr Bord",
  "block.minecraft.banner.border.purple": "Lila Bord",
  "block.minecraft.banner.border.red": "Rodorr Bord",
  "block.minecraft.banner.border.white": "Weeßorr Bord",
  "block.minecraft.banner.border.yellow": "Gelborr Bord",
  "block.minecraft.banner.bricks.black": "Fäld schworz gemauord",
  "block.minecraft.banner.bricks.blue": "Fäld blau gemauord",
  "block.minecraft.banner.bricks.brown": "Fäld braun gemauord",
  "block.minecraft.banner.bricks.cyan": "Fäld dürgis gemauord",
  "block.minecraft.banner.bricks.gray": "Fäld grau gemauord",
  "block.minecraft.banner.bricks.green": "Fäld grien gemauord",
  "block.minecraft.banner.bricks.light_blue": "Fäld hellblau gemauord",
  "block.minecraft.banner.bricks.light_gray": "Fäld hellgrau gemauord",
  "block.minecraft.banner.bricks.lime": "Feld hellgrien gemauord",
  "block.minecraft.banner.bricks.magenta": "Fäld magenda gemauord",
  "block.minecraft.banner.bricks.orange": "Fäld orangsch gemauord",
  "block.minecraft.banner.bricks.pink": "Fäld ping gemauord",
  "block.minecraft.banner.bricks.purple": "Fäld lila gemauord",
  "block.minecraft.banner.bricks.red": "Fäld rod gemauord",
  "block.minecraft.banner.bricks.white": "Fäld weeß gemauord",
  "block.minecraft.banner.bricks.yellow": "Fäld gelb gemauord",
  "block.minecraft.banner.circle.black": "Schworze Guchl",
  "block.minecraft.banner.circle.blue": "Blaue Guchl",
  "block.minecraft.banner.circle.brown": "Braune Guchl",
  "block.minecraft.banner.circle.cyan": "Dürgise Guchl",
  "block.minecraft.banner.circle.gray": "Graue Guchl",
  "block.minecraft.banner.circle.green": "Griene Guchl",
  "block.minecraft.banner.circle.light_blue": "Hellblaue Guchl",
  "block.minecraft.banner.circle.light_gray": "Hellgraue Guchl",
  "block.minecraft.banner.circle.lime": "Hellgriene Guchl",
  "block.minecraft.banner.circle.magenta": "Magenda Guchl",
  "block.minecraft.banner.circle.orange": "Orangsche Guchl",
  "block.minecraft.banner.circle.pink": "Pinge Guchl",
  "block.minecraft.banner.circle.purple": "Lila Guchl",
  "block.minecraft.banner.circle.red": "Rode Guchl",
  "block.minecraft.banner.circle.white": "Weeße Guchl",
  "block.minecraft.banner.circle.yellow": "Gelbe Guchl",
  "block.minecraft.banner.creeper.black": "Schworzorr Creeper",
  "block.minecraft.banner.creeper.blue": "Blauorr Creeper",
  "block.minecraft.banner.creeper.brown": "Braunorr Creeper",
  "block.minecraft.banner.creeper.cyan": "Dürgisorr Creeper",
  "block.minecraft.banner.creeper.gray": "Grauorr Creeper",
  "block.minecraft.banner.creeper.green": "Grienorr Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblauorr Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgrauorr Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrienorr Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenda Creeper",
  "block.minecraft.banner.creeper.orange": "Orangschorr Creeper",
  "block.minecraft.banner.creeper.pink": "Pingorr Creeper",
  "block.minecraft.banner.creeper.purple": "Lila Creeper",
  "block.minecraft.banner.creeper.red": "Rodorr Creeper",
  "block.minecraft.banner.creeper.white": "Weeßorr Creeper",
  "block.minecraft.banner.creeper.yellow": "Gelborr Creeper",
  "block.minecraft.banner.cross.black": "Schworzes Andreasgreuz",
  "block.minecraft.banner.cross.blue": "Blaues Andreasgreuz",
  "block.minecraft.banner.cross.brown": "Braunes Andreasgreuz",
  "block.minecraft.banner.cross.cyan": "Dürgises Andreasgreuz",
  "block.minecraft.banner.cross.gray": "Graues Andreasgreuz",
  "block.minecraft.banner.cross.green": "Grienes Andreasgreuz",
  "block.minecraft.banner.cross.light_blue": "Hellblaues Andreasgreuz",
  "block.minecraft.banner.cross.light_gray": "Hellgraues Andreasgreuz",
  "block.minecraft.banner.cross.lime": "Hellgrienes Andreasgreuz",
  "block.minecraft.banner.cross.magenta": "Magenda Andreasgreuz",
  "block.minecraft.banner.cross.orange": "Orangsches Andreasgreuz",
  "block.minecraft.banner.cross.pink": "Pinges Andreasgreuz",
  "block.minecraft.banner.cross.purple": "Lila Andreasgreuz",
  "block.minecraft.banner.cross.red": "Rodes Andreasgreuz",
  "block.minecraft.banner.cross.white": "Weeßes Andreasgreuz",
  "block.minecraft.banner.cross.yellow": "Gelbes Andreasgreuz",
  "block.minecraft.banner.curly_border.black": "Schworzorr Schbigglbord",
  "block.minecraft.banner.curly_border.blue": "Blauorr Schbigglbord",
  "block.minecraft.banner.curly_border.brown": "Braunorr Schbigglbord",
  "block.minecraft.banner.curly_border.cyan": "Dürgisorr Schbigglbord",
  "block.minecraft.banner.curly_border.gray": "Grauorr Schbigglbord",
  "block.minecraft.banner.curly_border.green": "Grienorr Schbigglbord",
  "block.minecraft.banner.curly_border.light_blue": "Hellblauorr Schbigglbord",
  "block.minecraft.banner.curly_border.light_gray": "Hellgrauorr Schbigglbord",
  "block.minecraft.banner.curly_border.lime": "Hellgrienorr Schbigglbord",
  "block.minecraft.banner.curly_border.magenta": "Magenda Schbigglbord",
  "block.minecraft.banner.curly_border.orange": "Orangschorr Schbigglbord",
  "block.minecraft.banner.curly_border.pink": "Pingorr Schbigglbord",
  "block.minecraft.banner.curly_border.purple": "Lila Schbigglbord",
  "block.minecraft.banner.curly_border.red": "Rodorr Schbigglbord",
  "block.minecraft.banner.curly_border.white": "Weeßorr Schbigglbord",
  "block.minecraft.banner.curly_border.yellow": "Gelborr Schbigglbord",
  "block.minecraft.banner.diagonal_left.black": "Schworz schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.blue": "Blau schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.brown": "Braun schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.cyan": "Dürgis schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.gray": "Grau schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.green": "Grien schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblaues schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgrau schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.lime": "Hellgrien schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.magenta": "Magenda schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.orange": "Orangsch schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.pink": "Ping schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.purple": "Lila schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.red": "Rod schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.white": "Weeß schrächlings gedeild",
  "block.minecraft.banner.diagonal_left.yellow": "Gelb schrächlings gedeild",
  "block.minecraft.banner.diagonal_right.black": "Schworz schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.brown": "Braun schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.cyan": "Dürgis schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.green": "Grien schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgrau schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.lime": "Hellgrien schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.magenta": "Magenda schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.orange": "Orangsch schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.pink": "Ping schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.purple": "Lila schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.red": "Rod schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.white": "Weeß schrächreschds gedeild",
  "block.minecraft.banner.diagonal_right.yellow": "Gelb schrächreschds gedeild",
  "block.minecraft.banner.diagonal_up_left.black": "Schworz schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.brown": "Braun schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Dürgis schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.green": "Grien schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgrau schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgrien schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenda schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orangsch schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.pink": "Ping schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.purple": "Lila schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.red": "Rod schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.white": "Weeß schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gelb schrächreschds gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.black": "Schworz schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.brown": "Braun schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Dürgis schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.green": "Grien schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgrau schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgrien schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenda schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orangsch schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.pink": "Ping schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.purple": "Lila schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.red": "Rod schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.white": "Weeß schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gelb schrächlings gedeild (Inverdiord)",
  "block.minecraft.banner.flow.black": "Schwarzer Fluss",
  "block.minecraft.banner.flow.blue": "Blauer Fluss",
  "block.minecraft.banner.flow.brown": "Brauner Fluss",
  "block.minecraft.banner.flow.cyan": "Türkiser Fluss",
  "block.minecraft.banner.flow.gray": "Grauer Fluss",
  "block.minecraft.banner.flow.green": "Grüner Fluss",
  "block.minecraft.banner.flow.light_blue": "Hellblauer Fluss",
  "block.minecraft.banner.flow.light_gray": "Hellgrauer Fluss",
  "block.minecraft.banner.flow.lime": "Hellgrüner Fluss",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Oranger Fluss",
  "block.minecraft.banner.flow.pink": "Rosa Fluss",
  "block.minecraft.banner.flow.purple": "Violetter Fluss",
  "block.minecraft.banner.flow.red": "Roter Fluss",
  "block.minecraft.banner.flow.white": "Weißer Fluss",
  "block.minecraft.banner.flow.yellow": "Gelber Fluss",
  "block.minecraft.banner.flower.black": "Schworze Blume",
  "block.minecraft.banner.flower.blue": "Blaue Blume",
  "block.minecraft.banner.flower.brown": "Braune Blume",
  "block.minecraft.banner.flower.cyan": "Dürgise Blume",
  "block.minecraft.banner.flower.gray": "Graue Blume",
  "block.minecraft.banner.flower.green": "Griene Blume",
  "block.minecraft.banner.flower.light_blue": "Hellblaue Blume",
  "block.minecraft.banner.flower.light_gray": "Hellgraue Blume",
  "block.minecraft.banner.flower.lime": "Hellgriene Blume",
  "block.minecraft.banner.flower.magenta": "Magenda Blume",
  "block.minecraft.banner.flower.orange": "Orangsche Blume",
  "block.minecraft.banner.flower.pink": "Pinge Blume",
  "block.minecraft.banner.flower.purple": "Lila Blume",
  "block.minecraft.banner.flower.red": "Rode Blume",
  "block.minecraft.banner.flower.white": "Weeße Blume",
  "block.minecraft.banner.flower.yellow": "Gelbe Blume",
  "block.minecraft.banner.globe.black": "Schworzorr Globus",
  "block.minecraft.banner.globe.blue": "Blauorr Globus",
  "block.minecraft.banner.globe.brown": "Braunorr Globus",
  "block.minecraft.banner.globe.cyan": "Dürgisorr Globus",
  "block.minecraft.banner.globe.gray": "Grauorr Globus",
  "block.minecraft.banner.globe.green": "Grienorr Globus",
  "block.minecraft.banner.globe.light_blue": "Hellblauorr Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgrauorr Globus",
  "block.minecraft.banner.globe.lime": "Hellgrienorr Globus",
  "block.minecraft.banner.globe.magenta": "Magenda Globus",
  "block.minecraft.banner.globe.orange": "Orangschorr Globus",
  "block.minecraft.banner.globe.pink": "Pingorr Globus",
  "block.minecraft.banner.globe.purple": "Lila Globus",
  "block.minecraft.banner.globe.red": "Rodorr Globus",
  "block.minecraft.banner.globe.white": "Weeßorr Globus",
  "block.minecraft.banner.globe.yellow": "Gelborr Globus",
  "block.minecraft.banner.gradient.black": "Schworzorr Farbvorloof",
  "block.minecraft.banner.gradient.blue": "Blauorr Farbvorloof",
  "block.minecraft.banner.gradient.brown": "Braunorr Farbvorloof",
  "block.minecraft.banner.gradient.cyan": "Dürgisorr Farbvorloof",
  "block.minecraft.banner.gradient.gray": "Grauorr Farbvorloof",
  "block.minecraft.banner.gradient.green": "Grienorr Farbvorloof",
  "block.minecraft.banner.gradient.light_blue": "Hellblauorr Farbvorloof",
  "block.minecraft.banner.gradient.light_gray": "Hellgrauorr Farbvorloof",
  "block.minecraft.banner.gradient.lime": "Hellgrienorr Farbvorloof",
  "block.minecraft.banner.gradient.magenta": "Magenda Farbvorloof",
  "block.minecraft.banner.gradient.orange": "Orangschorr Farbvorloof",
  "block.minecraft.banner.gradient.pink": "Pingorr Farbvorloof",
  "block.minecraft.banner.gradient.purple": "Lila Farbvorloof",
  "block.minecraft.banner.gradient.red": "Rodorr Farbvorloof",
  "block.minecraft.banner.gradient.white": "Weeßorr Farbvorloof",
  "block.minecraft.banner.gradient.yellow": "Gelborr Farbvorloof",
  "block.minecraft.banner.gradient_up.black": "Schworzorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.blue": "Blauorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.brown": "Braunorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.cyan": "Dürgisorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.gray": "Grauorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.green": "Grienorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblauorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgrauorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrienorr Farbvorloof (Inverdierd)",
  "block.minecraft.banner.gradient_up.magenta": "Magenda Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.orange": "Orangschorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.pink": "Pingorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.purple": "Lila Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.red": "Rodorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.white": "Weeßorr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.gradient_up.yellow": "Gelborr Farbvorloof (Inverdiord)",
  "block.minecraft.banner.guster.black": "Schwarzer Windstoßer",
  "block.minecraft.banner.guster.blue": "Blauer Windstoßer",
  "block.minecraft.banner.guster.brown": "Brauner Windstoßer",
  "block.minecraft.banner.guster.cyan": "Türkiser Windstoßer",
  "block.minecraft.banner.guster.gray": "Grauer Windstoßer",
  "block.minecraft.banner.guster.green": "Grüner Windstoßer",
  "block.minecraft.banner.guster.light_blue": "Hellblauer Windstoßer",
  "block.minecraft.banner.guster.light_gray": "Hellgrauer Windstoßer",
  "block.minecraft.banner.guster.lime": "Hellgrüner Windstoßer",
  "block.minecraft.banner.guster.magenta": "Magenta Windstoßer",
  "block.minecraft.banner.guster.orange": "Oranger Windstoßer",
  "block.minecraft.banner.guster.pink": "Rosa Windstoßer",
  "block.minecraft.banner.guster.purple": "Violetter Windstoßer",
  "block.minecraft.banner.guster.red": "Roter Windstoßer",
  "block.minecraft.banner.guster.white": "Weißer Windstoßer",
  "block.minecraft.banner.guster.yellow": "Gelber Windstoßer",
  "block.minecraft.banner.half_horizontal.black": "Oobn schworz gedeild",
  "block.minecraft.banner.half_horizontal.blue": "Oobn blau gedeild",
  "block.minecraft.banner.half_horizontal.brown": "Oobn braun gedeild",
  "block.minecraft.banner.half_horizontal.cyan": "Oobn dürgis gedeild",
  "block.minecraft.banner.half_horizontal.gray": "Oobn grau gedeild",
  "block.minecraft.banner.half_horizontal.green": "Oobn grien gedeild",
  "block.minecraft.banner.half_horizontal.light_blue": "Oobn hellblau gedeild",
  "block.minecraft.banner.half_horizontal.light_gray": "Oobn hellgrau gedeild",
  "block.minecraft.banner.half_horizontal.lime": "Oobn hellgrien gedeild",
  "block.minecraft.banner.half_horizontal.magenta": "Oobn magenda gedeild",
  "block.minecraft.banner.half_horizontal.orange": "Oobn orangsch gedeild",
  "block.minecraft.banner.half_horizontal.pink": "Oobn ping gedeild",
  "block.minecraft.banner.half_horizontal.purple": "Oobn lila gedeild",
  "block.minecraft.banner.half_horizontal.red": "Oobn rod gedeild",
  "block.minecraft.banner.half_horizontal.white": "Oobn weeß gedeild",
  "block.minecraft.banner.half_horizontal.yellow": "Oobn gelb gedeild",
  "block.minecraft.banner.half_horizontal_bottom.black": "Und’n schworz gedeild",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Und’n blau gedeild",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Und’n braun gedeild",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Und’n dürgis gedeild",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Und’n grau gedeild",
  "block.minecraft.banner.half_horizontal_bottom.green": "Und’n grien gedeild",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Und’n hellblau gedeild",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Und’n hellgrau gedeild",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Und’n hellgrien gedeild",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Und’n magenda gedeild",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Und’n orangsch gedeild",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Und’n ping gedeild",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Und’n lila gedeild",
  "block.minecraft.banner.half_horizontal_bottom.red": "Und’n rod gedeild",
  "block.minecraft.banner.half_horizontal_bottom.white": "Und’n weeß gedeild",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Und’n gelb gedeild",
  "block.minecraft.banner.half_vertical.black": "Reschds schworz geschbaldn",
  "block.minecraft.banner.half_vertical.blue": "Reschds blau geschbaldn",
  "block.minecraft.banner.half_vertical.brown": "Reschds braun geschbaldn",
  "block.minecraft.banner.half_vertical.cyan": "Reschds dürgis geschbaldn",
  "block.minecraft.banner.half_vertical.gray": "Reschds grau geschbaldn",
  "block.minecraft.banner.half_vertical.green": "Reschds grien geschbaldn",
  "block.minecraft.banner.half_vertical.light_blue": "Reschds hellblau geschbaldn",
  "block.minecraft.banner.half_vertical.light_gray": "Reschds hellgrau geschbaldn",
  "block.minecraft.banner.half_vertical.lime": "Reschds hellgrien geschbaldn",
  "block.minecraft.banner.half_vertical.magenta": "Reschds magenda geschbaldn",
  "block.minecraft.banner.half_vertical.orange": "Reschds orangsch geschbaldn",
  "block.minecraft.banner.half_vertical.pink": "Reschds ping geschbaldn",
  "block.minecraft.banner.half_vertical.purple": "Reschds lila geschbaldn",
  "block.minecraft.banner.half_vertical.red": "Reschds rod geschbaldn",
  "block.minecraft.banner.half_vertical.white": "Reschds weeß geschbaldn",
  "block.minecraft.banner.half_vertical.yellow": "Reschds gelb geschbaldn",
  "block.minecraft.banner.half_vertical_right.black": "Lings schworz geschbaldn",
  "block.minecraft.banner.half_vertical_right.blue": "Lings blau geschbaldn",
  "block.minecraft.banner.half_vertical_right.brown": "Lings braun geschbaldn",
  "block.minecraft.banner.half_vertical_right.cyan": "Lings dürgis geschbaldn",
  "block.minecraft.banner.half_vertical_right.gray": "Lings grau geschbaldn",
  "block.minecraft.banner.half_vertical_right.green": "Lings grien geschbaldn",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lings hellblau geschbaldn",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lings hellgrau geschbaldn",
  "block.minecraft.banner.half_vertical_right.lime": "Lings hellgrien geschbaldn",
  "block.minecraft.banner.half_vertical_right.magenta": "Lings magenda geschbaldn",
  "block.minecraft.banner.half_vertical_right.orange": "Lings orangsch geschbaldn",
  "block.minecraft.banner.half_vertical_right.pink": "Lings ping geschbaldn",
  "block.minecraft.banner.half_vertical_right.purple": "Lings lila geschbaldn",
  "block.minecraft.banner.half_vertical_right.red": "Lings rod geschbaldn",
  "block.minecraft.banner.half_vertical_right.white": "Lings weeß geschbaldn",
  "block.minecraft.banner.half_vertical_right.yellow": "Lings gelb geschbaldn",
  "block.minecraft.banner.mojang.black": "Schworzes Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaues Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Braunes Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Dürgises Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graues Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Grienes Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblaues Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgraues Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Hellgrienes Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenda Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Orangsches Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Pinges Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Lila Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rodes Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Weeßes Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gelbes Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schworze Gusche",
  "block.minecraft.banner.piglin.blue": "Blaue Gusche",
  "block.minecraft.banner.piglin.brown": "Braune Gusche",
  "block.minecraft.banner.piglin.cyan": "Dürgise Gusche",
  "block.minecraft.banner.piglin.gray": "Graue Gusche",
  "block.minecraft.banner.piglin.green": "Griene Gusche",
  "block.minecraft.banner.piglin.light_blue": "Hellblaue Gusche",
  "block.minecraft.banner.piglin.light_gray": "Hellgraue Gusche",
  "block.minecraft.banner.piglin.lime": "Hellgriene Gusche",
  "block.minecraft.banner.piglin.magenta": "Magenda Gusche",
  "block.minecraft.banner.piglin.orange": "Orangsche Gusche",
  "block.minecraft.banner.piglin.pink": "Pinge Gusche",
  "block.minecraft.banner.piglin.purple": "Lila Gusche",
  "block.minecraft.banner.piglin.red": "Rode Gusche",
  "block.minecraft.banner.piglin.white": "Weeße Gusche",
  "block.minecraft.banner.piglin.yellow": "Gelbe Gusche",
  "block.minecraft.banner.rhombus.black": "Schworze Raude",
  "block.minecraft.banner.rhombus.blue": "Blaue Raude",
  "block.minecraft.banner.rhombus.brown": "Braune Raude",
  "block.minecraft.banner.rhombus.cyan": "Dürgise Raude",
  "block.minecraft.banner.rhombus.gray": "Graue Raude",
  "block.minecraft.banner.rhombus.green": "Griene Raude",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaue Raude",
  "block.minecraft.banner.rhombus.light_gray": "Hellgraue Raude",
  "block.minecraft.banner.rhombus.lime": "Hellgriene Raude",
  "block.minecraft.banner.rhombus.magenta": "Magenda Raude",
  "block.minecraft.banner.rhombus.orange": "Orangsche Raude",
  "block.minecraft.banner.rhombus.pink": "Pinge Raude",
  "block.minecraft.banner.rhombus.purple": "Lila Raude",
  "block.minecraft.banner.rhombus.red": "Rode Raude",
  "block.minecraft.banner.rhombus.white": "Weeße Raude",
  "block.minecraft.banner.rhombus.yellow": "Gelbe Raude",
  "block.minecraft.banner.skull.black": "Schworzorr Nischl",
  "block.minecraft.banner.skull.blue": "Blauorr Nischl",
  "block.minecraft.banner.skull.brown": "Braunorr Nischl",
  "block.minecraft.banner.skull.cyan": "Dürgisorr Nischl",
  "block.minecraft.banner.skull.gray": "Grauorr Nischl",
  "block.minecraft.banner.skull.green": "Grienorr Nischl",
  "block.minecraft.banner.skull.light_blue": "Hellblauorr Nischl",
  "block.minecraft.banner.skull.light_gray": "Hellgrauorr Nischl",
  "block.minecraft.banner.skull.lime": "Hellgrienorr Nischl",
  "block.minecraft.banner.skull.magenta": "Magenda Nischl",
  "block.minecraft.banner.skull.orange": "Orangschorr Nischl",
  "block.minecraft.banner.skull.pink": "Pingorr Nischl",
  "block.minecraft.banner.skull.purple": "Lila Nischl",
  "block.minecraft.banner.skull.red": "Rodorr Nischl",
  "block.minecraft.banner.skull.white": "Weeßorr Nischl",
  "block.minecraft.banner.skull.yellow": "Gelborr Nischl",
  "block.minecraft.banner.small_stripes.black": "Fiorr schworze Pfähle",
  "block.minecraft.banner.small_stripes.blue": "Fiorr blaue Pfähle",
  "block.minecraft.banner.small_stripes.brown": "Fiorr braune Pfähle",
  "block.minecraft.banner.small_stripes.cyan": "Fiorr dürgise Pfähle",
  "block.minecraft.banner.small_stripes.gray": "Fiorr graue Pfähle",
  "block.minecraft.banner.small_stripes.green": "Fiorr griene Pfähle",
  "block.minecraft.banner.small_stripes.light_blue": "Fiorr hellblaue Pfähle",
  "block.minecraft.banner.small_stripes.light_gray": "Fiorr hellgraue Pfähle",
  "block.minecraft.banner.small_stripes.lime": "Fiorr hellgriene Pfähle",
  "block.minecraft.banner.small_stripes.magenta": "Fiorr magenda Pfähle",
  "block.minecraft.banner.small_stripes.orange": "Fiorr orangsche Pfähle",
  "block.minecraft.banner.small_stripes.pink": "Fiorr pinge Pfähle",
  "block.minecraft.banner.small_stripes.purple": "Fiorr lila Pfähle",
  "block.minecraft.banner.small_stripes.red": "Fiorr rode Pfähle",
  "block.minecraft.banner.small_stripes.white": "Fiorr weeße Pfähle",
  "block.minecraft.banner.small_stripes.yellow": "Fiorr gelbe Pfähle",
  "block.minecraft.banner.square_bottom_left.black": "Schworzes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.blue": "Blaues reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.brown": "Braunes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.cyan": "Dürgises reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.gray": "Graues reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.green": "Grienes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblaues reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgraues reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgrienes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenda reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.orange": "Orangsches reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.pink": "Pinges reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.purple": "Lila reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.red": "Rodes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.white": "Weeßes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_left.yellow": "Gelbes reschdes Undorregg",
  "block.minecraft.banner.square_bottom_right.black": "Schworzes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.blue": "Blaues linges Undorregg",
  "block.minecraft.banner.square_bottom_right.brown": "Braunes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.cyan": "Dürgises linges Undorregg",
  "block.minecraft.banner.square_bottom_right.gray": "Graues linges Undorregg",
  "block.minecraft.banner.square_bottom_right.green": "Grienes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblaues linges Undorregg",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgraues linges Undorregg",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgrienes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenda linges Undorregg",
  "block.minecraft.banner.square_bottom_right.orange": "Orangsches linges Undorregg",
  "block.minecraft.banner.square_bottom_right.pink": "Pinges linges Undorregg",
  "block.minecraft.banner.square_bottom_right.purple": "Lila linges Undorregg",
  "block.minecraft.banner.square_bottom_right.red": "Rodes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.white": "Weeßes linges Undorregg",
  "block.minecraft.banner.square_bottom_right.yellow": "Gelbes linges Undorregg",
  "block.minecraft.banner.square_top_left.black": "Schworzes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.blue": "Blaues reschdes Oborregg",
  "block.minecraft.banner.square_top_left.brown": "Braunes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.cyan": "Dürgises reschdes Oborregg",
  "block.minecraft.banner.square_top_left.gray": "Graues reschdes Oborregg",
  "block.minecraft.banner.square_top_left.green": "Grienes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblaues reschdes Oborregg",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgraues reschdes Oborregg",
  "block.minecraft.banner.square_top_left.lime": "Hellgrienes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.magenta": "Lila reschdes Oborregg",
  "block.minecraft.banner.square_top_left.orange": "Orangsches reschdes Oborregg",
  "block.minecraft.banner.square_top_left.pink": "Pinges reschdes Oborregg",
  "block.minecraft.banner.square_top_left.purple": "Lila reschdes Oborregg",
  "block.minecraft.banner.square_top_left.red": "Rodes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.white": "Weeßes reschdes Oborregg",
  "block.minecraft.banner.square_top_left.yellow": "Gelbes reschdes Oborregg",
  "block.minecraft.banner.square_top_right.black": "Schworzes linges Oborregg",
  "block.minecraft.banner.square_top_right.blue": "Blaues linges Oborregg",
  "block.minecraft.banner.square_top_right.brown": "Braunes linges Oborregg",
  "block.minecraft.banner.square_top_right.cyan": "Dürgises linges Oborregg",
  "block.minecraft.banner.square_top_right.gray": "Graues linges Oborregg",
  "block.minecraft.banner.square_top_right.green": "Grienes linges Oborregg",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblaues linges Oborregg",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgraues linges Oborregg",
  "block.minecraft.banner.square_top_right.lime": "Hellgrienes linges Oborregg",
  "block.minecraft.banner.square_top_right.magenta": "Lila linges Oborregg",
  "block.minecraft.banner.square_top_right.orange": "Orangsches linges Oborregg",
  "block.minecraft.banner.square_top_right.pink": "Pinges linges Oborregg",
  "block.minecraft.banner.square_top_right.purple": "Lila linges Oborregg",
  "block.minecraft.banner.square_top_right.red": "Rodes linges Oborregg",
  "block.minecraft.banner.square_top_right.white": "Weeßes linges Oborregg",
  "block.minecraft.banner.square_top_right.yellow": "Gelbes linges Oborregg",
  "block.minecraft.banner.straight_cross.black": "Schworzes Greuz",
  "block.minecraft.banner.straight_cross.blue": "Blaues Greuz",
  "block.minecraft.banner.straight_cross.brown": "Braunes Greuz",
  "block.minecraft.banner.straight_cross.cyan": "Dürgises Greuz",
  "block.minecraft.banner.straight_cross.gray": "Graues Greuz",
  "block.minecraft.banner.straight_cross.green": "Grienes Greuz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblaues Greuz",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgraues Greuz",
  "block.minecraft.banner.straight_cross.lime": "Hellgrienes Greuz",
  "block.minecraft.banner.straight_cross.magenta": "Magenda Greuz",
  "block.minecraft.banner.straight_cross.orange": "Orangsches Greuz",
  "block.minecraft.banner.straight_cross.pink": "Pinges Greuz",
  "block.minecraft.banner.straight_cross.purple": "Lila Greuz",
  "block.minecraft.banner.straight_cross.red": "Rodes Greuz",
  "block.minecraft.banner.straight_cross.white": "Weeßes Greuz",
  "block.minecraft.banner.straight_cross.yellow": "Gelbes Greuz",
  "block.minecraft.banner.stripe_bottom.black": "Schworzorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.blue": "Blauorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.brown": "Braunorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.cyan": "Dürgisorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.gray": "Grauorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.green": "Grienorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblauorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellgrauorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrienorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenda Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.orange": "Orangschorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.pink": "Pingorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.purple": "Lila Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.red": "Rodorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.white": "Weeßorr Bannorrfuß",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelborr Bannorrfuß",
  "block.minecraft.banner.stripe_center.black": "Schworzorr Pfahl",
  "block.minecraft.banner.stripe_center.blue": "Blauorr Pfahl",
  "block.minecraft.banner.stripe_center.brown": "Braunorr Pfahl",
  "block.minecraft.banner.stripe_center.cyan": "Dürgisorr Pfahl",
  "block.minecraft.banner.stripe_center.gray": "Grauorr Pfahl",
  "block.minecraft.banner.stripe_center.green": "Grienorr Pfahl",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblauorr Pfahl",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgrauorr Pfahl",
  "block.minecraft.banner.stripe_center.lime": "Hellgrienorr Pfahl",
  "block.minecraft.banner.stripe_center.magenta": "Magenda Pfahl",
  "block.minecraft.banner.stripe_center.orange": "Orangschorr Pfahl",
  "block.minecraft.banner.stripe_center.pink": "Pingorr Pfahl",
  "block.minecraft.banner.stripe_center.purple": "Lila Pfahl",
  "block.minecraft.banner.stripe_center.red": "Rodorr Pfahl",
  "block.minecraft.banner.stripe_center.white": "Weeßorr Pfahl",
  "block.minecraft.banner.stripe_center.yellow": "Gelborr Pfahl",
  "block.minecraft.banner.stripe_downleft.black": "Schworzorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.blue": "Blauorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.brown": "Braunorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.cyan": "Dürgisorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.gray": "Grauorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.green": "Grienorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblauorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgrauorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgrienorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenda Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.orange": "Orangschorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.pink": "Pingorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.purple": "Lila Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.red": "Rodorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.white": "Weeßorr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelborr Schrächlingsbalgn",
  "block.minecraft.banner.stripe_downright.black": "Schworzorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.blue": "Blauorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.brown": "Braunorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.cyan": "Dürgisorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.gray": "Grauorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.green": "Grienorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblauorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgrauorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.lime": "Hellgrienorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.magenta": "Magenda Schrächbalgn",
  "block.minecraft.banner.stripe_downright.orange": "Orangschorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.pink": "Pingorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.purple": "Lila Schrächbalgn",
  "block.minecraft.banner.stripe_downright.red": "Rodorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.white": "Weeßorr Schrächbalgn",
  "block.minecraft.banner.stripe_downright.yellow": "Gelborr Schrächbalgn",
  "block.minecraft.banner.stripe_left.black": "Schworze reschde Flange",
  "block.minecraft.banner.stripe_left.blue": "Blaue reschde Flange",
  "block.minecraft.banner.stripe_left.brown": "Braune reschde Flange",
  "block.minecraft.banner.stripe_left.cyan": "Dürgise reschde Flange",
  "block.minecraft.banner.stripe_left.gray": "Graue reschde Flange",
  "block.minecraft.banner.stripe_left.green": "Griene reschde Flange",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblaue reschde Flange",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgraue reschde Flange",
  "block.minecraft.banner.stripe_left.lime": "Hellgriene reschde Flange",
  "block.minecraft.banner.stripe_left.magenta": "Magenda reschde Flange",
  "block.minecraft.banner.stripe_left.orange": "Orangsche reschde Flange",
  "block.minecraft.banner.stripe_left.pink": "Pinge reschde Flange",
  "block.minecraft.banner.stripe_left.purple": "Lila reschde Flange",
  "block.minecraft.banner.stripe_left.red": "Rode reschde Flange",
  "block.minecraft.banner.stripe_left.white": "Weeße reschde Flange",
  "block.minecraft.banner.stripe_left.yellow": "Gelbe reschde Flange",
  "block.minecraft.banner.stripe_middle.black": "Schworzorr Balgn",
  "block.minecraft.banner.stripe_middle.blue": "Blauorr Balgn",
  "block.minecraft.banner.stripe_middle.brown": "Braunorr Balgn",
  "block.minecraft.banner.stripe_middle.cyan": "Dürgisorr Balgn",
  "block.minecraft.banner.stripe_middle.gray": "Grauorr Balgn",
  "block.minecraft.banner.stripe_middle.green": "Grienorr Balgn",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblauorr Balgn",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgrauorr Balgn",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrienorr Balgn",
  "block.minecraft.banner.stripe_middle.magenta": "Magenda Balgn",
  "block.minecraft.banner.stripe_middle.orange": "Orangschorr Balgn",
  "block.minecraft.banner.stripe_middle.pink": "Pingorr Balgn",
  "block.minecraft.banner.stripe_middle.purple": "Lila Balgn",
  "block.minecraft.banner.stripe_middle.red": "Rodorr Balgn",
  "block.minecraft.banner.stripe_middle.white": "Weeßorr Balgn",
  "block.minecraft.banner.stripe_middle.yellow": "Gelborr Balgn",
  "block.minecraft.banner.stripe_right.black": "Schworze linge Flange",
  "block.minecraft.banner.stripe_right.blue": "Blaue linge Flange",
  "block.minecraft.banner.stripe_right.brown": "Braune linge Flange",
  "block.minecraft.banner.stripe_right.cyan": "Dürgise linge Flange",
  "block.minecraft.banner.stripe_right.gray": "Graue linge Flange",
  "block.minecraft.banner.stripe_right.green": "Griene linge Flange",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblaue linge Flange",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgraue linge Flange",
  "block.minecraft.banner.stripe_right.lime": "Hellgriene linge Flange",
  "block.minecraft.banner.stripe_right.magenta": "Magenda linge Flange",
  "block.minecraft.banner.stripe_right.orange": "Orangsche linge Flange",
  "block.minecraft.banner.stripe_right.pink": "Pinge linge Flange",
  "block.minecraft.banner.stripe_right.purple": "Lila linge Flange",
  "block.minecraft.banner.stripe_right.red": "Rode linge Flange",
  "block.minecraft.banner.stripe_right.white": "Weeße linge Flange",
  "block.minecraft.banner.stripe_right.yellow": "Gelbe linge Flange",
  "block.minecraft.banner.stripe_top.black": "Schworzes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.blue": "Blaues Bannorrhaubd",
  "block.minecraft.banner.stripe_top.brown": "Braunes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.cyan": "Dürgises Bannorrhaubd",
  "block.minecraft.banner.stripe_top.gray": "Graues Bannorrhaubd",
  "block.minecraft.banner.stripe_top.green": "Grienes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaues Bannorrhaubd",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgraues Bannorrhaubd",
  "block.minecraft.banner.stripe_top.lime": "Hellgrienes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.magenta": "Magenda Bannorrhaubd",
  "block.minecraft.banner.stripe_top.orange": "Orangsches Bannorrhaubd",
  "block.minecraft.banner.stripe_top.pink": "Pinges Bannorrhaubd",
  "block.minecraft.banner.stripe_top.purple": "Lila Bannorrhaubd",
  "block.minecraft.banner.stripe_top.red": "Rodes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.white": "Weeßes Bannorrhaubd",
  "block.minecraft.banner.stripe_top.yellow": "Gelbes Bannorrhaubd",
  "block.minecraft.banner.triangle_bottom.black": "Schworze halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.blue": "Blaue halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.brown": "Braune halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.cyan": "Dürgise halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.gray": "Graue halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.green": "Griene halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblaue halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgraue halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgriene halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenda halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.orange": "Orangsche halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.pink": "Pinge halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.purple": "Lila halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.red": "Rode halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.white": "Weeße halbe Schbidze",
  "block.minecraft.banner.triangle_bottom.yellow": "Gelbe halbe Schbidze",
  "block.minecraft.banner.triangle_top.black": "Schworze geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.blue": "Blaue geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.brown": "Braune geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.cyan": "Dürgise geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.gray": "Graue geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.green": "Griene geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblaue geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgraue geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.lime": "Hellgriene geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.magenta": "Magenda geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.orange": "Orangsche geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.pink": "Pinge geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.purple": "Lila geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.red": "Rode geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.white": "Weeße geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangle_top.yellow": "Gelbe geschdürzde halbe Schbidze",
  "block.minecraft.banner.triangles_bottom.black": "Schworzorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.blue": "Blauorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.brown": "Braunorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.cyan": "Dürgisorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.gray": "Grauorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.green": "Grienorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblauorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgrauorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgrienorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenda geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.orange": "Orangschorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.pink": "Pingorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.purple": "Lila geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.red": "Rodorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.white": "Weeßorr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_bottom.yellow": "Gelborr geschbiggeldorr Bannorrfuß",
  "block.minecraft.banner.triangles_top.black": "Schworzes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.blue": "Blaues geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.brown": "Braunes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.cyan": "Dürgises geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.gray": "Graues geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.green": "Grienes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaues geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgraues geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.lime": "Hellgrienes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.magenta": "Magenda geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.orange": "Orangsches geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.pink": "Pinges geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.purple": "Lila geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.red": "Rodes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.white": "Weeßes geschbiggeldes Bannorrhaubd",
  "block.minecraft.banner.triangles_top.yellow": "Gelbes geschbiggeldes Bannorrhaubd",
  "block.minecraft.barrel": "Fass",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basald",
  "block.minecraft.beacon": "Leuschdfeuorr",
  "block.minecraft.beacon.primary": "Brimäre Grafd",
  "block.minecraft.beacon.secondary": "Segundäre Grafd",
  "block.minecraft.bed.no_sleep": "Du kannsd nur nachds odorr bei Gewiddorr schlafn",
  "block.minecraft.bed.not_safe": "Du kannsd jäddse nisch schlafn, es sin Monsdorr in dorr Nähe",
  "block.minecraft.bed.obstructed": "Dieses Bädde is bloggierd",
  "block.minecraft.bed.occupied": "Dieses Bädde is beleeschd",
  "block.minecraft.bed.too_far_away": "Du kannsd jäddse nisch schlafn, das Bädde is zu weid endfernd",
  "block.minecraft.bedrock": "Grundgeschdeen",
  "block.minecraft.bee_nest": "Biennesd",
  "block.minecraft.beehive": "Bienschdogg",
  "block.minecraft.beetroots": "Rode Beede",
  "block.minecraft.bell": "Glogge",
  "block.minecraft.big_dripleaf": "Großes Drobbbladd",
  "block.minecraft.big_dripleaf_stem": "Großorr Drobbbladdschdiel",
  "block.minecraft.birch_button": "Bürschnhulzgnopp",
  "block.minecraft.birch_door": "Bürschnhulzdiere",
  "block.minecraft.birch_fence": "Bürschnhulzzaun",
  "block.minecraft.birch_fence_gate": "Bürschnhulzzaundorr",
  "block.minecraft.birch_hanging_sign": "Bürschnhulzhängeschüld",
  "block.minecraft.birch_leaves": "Bürschnlaub",
  "block.minecraft.birch_log": "Bürschnschdamm",
  "block.minecraft.birch_planks": "Bürschnhulzbreddorr",
  "block.minecraft.birch_pressure_plate": "Bürschnhulzdruggbladde",
  "block.minecraft.birch_sapling": "Bürschnseddsling",
  "block.minecraft.birch_shelf": "Birgenholzregal",
  "block.minecraft.birch_sign": "Bürschnhulzschüld",
  "block.minecraft.birch_slab": "Bürschnhulzschdufe",
  "block.minecraft.birch_stairs": "Bürschnhulzdrebbe",
  "block.minecraft.birch_trapdoor": "Bürschnhulzfalldiere",
  "block.minecraft.birch_wall_hanging_sign": "Bürschnhulzwandhängeschüld",
  "block.minecraft.birch_wall_sign": "Bürschnhulzwandschüld",
  "block.minecraft.birch_wood": "Bürschnhulz",
  "block.minecraft.black_banner": "Schworzes Bannorr",
  "block.minecraft.black_bed": "Schworzes Bädde",
  "block.minecraft.black_candle": "Schworze Gerdse",
  "block.minecraft.black_candle_cake": "Guchn mid schworzorr Gerdse",
  "block.minecraft.black_carpet": "Schwarzorr Täppsch",
  "block.minecraft.black_concrete": "Schworzorr Bedong",
  "block.minecraft.black_concrete_powder": "Schworzorr Droggnbedong",
  "block.minecraft.black_glazed_terracotta": "Schworze glasierde Geramigg",
  "block.minecraft.black_shulker_box": "Schworze Shulker-Gissde",
  "block.minecraft.black_stained_glass": "Schworzes Glas",
  "block.minecraft.black_stained_glass_pane": "Schworze Glasscheebe",
  "block.minecraft.black_terracotta": "Schworze Geramigg",
  "block.minecraft.black_wool": "Schworze Wolle",
  "block.minecraft.blackstone": "Schworzschdeen",
  "block.minecraft.blackstone_slab": "Schworzschdeenschdufe",
  "block.minecraft.blackstone_stairs": "Schworzschdeendrebbe",
  "block.minecraft.blackstone_wall": "Schworzschdeenmauor",
  "block.minecraft.blast_furnace": "Schmelzofn",
  "block.minecraft.blue_banner": "Blaues Bannorr",
  "block.minecraft.blue_bed": "Blaues Bädde",
  "block.minecraft.blue_candle": "Blaue Gerdse",
  "block.minecraft.blue_candle_cake": "Guchn mid blauorr Gerdse",
  "block.minecraft.blue_carpet": "Blauorr Täppsch",
  "block.minecraft.blue_concrete": "Blauorr Bedong",
  "block.minecraft.blue_concrete_powder": "Blauorr Droggnbedong",
  "block.minecraft.blue_glazed_terracotta": "Blaue glasierde Geramigg",
  "block.minecraft.blue_ice": "Blaues Eis",
  "block.minecraft.blue_orchid": "Blaue Orchidee",
  "block.minecraft.blue_shulker_box": "Blaue Shulker-Gissde",
  "block.minecraft.blue_stained_glass": "Blaues Glas",
  "block.minecraft.blue_stained_glass_pane": "Blaue Glasscheebe",
  "block.minecraft.blue_terracotta": "Blaue Geramigg",
  "block.minecraft.blue_wool": "Blaue Wolle",
  "block.minecraft.bone_block": "Gnochnblogg",
  "block.minecraft.bookshelf": "Schwahrdnregal",
  "block.minecraft.brain_coral": "Hirngoralle",
  "block.minecraft.brain_coral_block": "Hirngorallnblogg",
  "block.minecraft.brain_coral_fan": "Hirngorallnfäschorr",
  "block.minecraft.brain_coral_wall_fan": "Hirngorallnwandfäschorr",
  "block.minecraft.brewing_stand": "Brauschdand",
  "block.minecraft.brick_slab": "Zieschlschdufe",
  "block.minecraft.brick_stairs": "Zieschldrebbe",
  "block.minecraft.brick_wall": "Zieschlschdeenmauor",
  "block.minecraft.bricks": "Zieschl",
  "block.minecraft.brown_banner": "Braunes Bannorr",
  "block.minecraft.brown_bed": "Braunes Bädde",
  "block.minecraft.brown_candle": "Braune Gerdse",
  "block.minecraft.brown_candle_cake": "Guchn mid braunorr Gerdse",
  "block.minecraft.brown_carpet": "Braunorr Täppsch",
  "block.minecraft.brown_concrete": "Braunorr Bedong",
  "block.minecraft.brown_concrete_powder": "Braunorr Droggnbedong",
  "block.minecraft.brown_glazed_terracotta": "Braune glasierde Geramigg",
  "block.minecraft.brown_mushroom": "Braunorr Bilz",
  "block.minecraft.brown_mushroom_block": "Braunorr Bilzblogg",
  "block.minecraft.brown_shulker_box": "Braune Shulker-Gissde",
  "block.minecraft.brown_stained_glass": "Braunes Glas",
  "block.minecraft.brown_stained_glass_pane": "Braune Glasscheebe",
  "block.minecraft.brown_terracotta": "Braune Geramigg",
  "block.minecraft.brown_wool": "Braune Wolle",
  "block.minecraft.bubble_column": "Blasnsäule",
  "block.minecraft.bubble_coral": "Blasngoralle",
  "block.minecraft.bubble_coral_block": "Blasngorallnblogg",
  "block.minecraft.bubble_coral_fan": "Blasngorallnfäschorr",
  "block.minecraft.bubble_coral_wall_fan": "Blasngorallnwandfäschorr",
  "block.minecraft.budding_amethyst": "Gnosbende Amethystdruse",
  "block.minecraft.bush": "Büschl",
  "block.minecraft.cactus": "Gaggdus",
  "block.minecraft.cactus_flower": "Gagdusblüde",
  "block.minecraft.cake": "Guchn",
  "block.minecraft.calcite": "Galzid",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrierte Schulkensor",
  "block.minecraft.campfire": "Gnäggorrschn",
  "block.minecraft.candle": "Gerdse",
  "block.minecraft.candle_cake": "Guchn mid Gerdse",
  "block.minecraft.carrots": "Möhrn",
  "block.minecraft.cartography_table": "Gardndisch",
  "block.minecraft.carved_pumpkin": "Geschnidzdorr Gürbis",
  "block.minecraft.cauldron": "Gessl",
  "block.minecraft.cave_air": "Höhlnlufd",
  "block.minecraft.cave_vines": "Höhlnrangn",
  "block.minecraft.cave_vines_plant": "Höhlnrangnpflanze",
  "block.minecraft.chain": "Kedde",
  "block.minecraft.chain_command_block": "Keddn-Befählsblogg",
  "block.minecraft.cherry_button": "Kirschknopf",
  "block.minecraft.cherry_door": "Kirschendier",
  "block.minecraft.cherry_fence": "Kirschenzaun",
  "block.minecraft.cherry_fence_gate": "Kirschentür",
  "block.minecraft.cherry_hanging_sign": "Kirschenhängeschild",
  "block.minecraft.cherry_leaves": "Kirschelüüch",
  "block.minecraft.cherry_log": "Kirschendiele",
  "block.minecraft.cherry_planks": "Kirschendieln",
  "block.minecraft.cherry_pressure_plate": "Kirschedruckplatte",
  "block.minecraft.cherry_sapling": "Kirschensetzling",
  "block.minecraft.cherry_shelf": "Girschholzregal",
  "block.minecraft.cherry_sign": "Kirschenschild",
  "block.minecraft.cherry_slab": "Kirschenschwipp",
  "block.minecraft.cherry_stairs": "Kirschentreppe",
  "block.minecraft.cherry_trapdoor": "Kirschentür",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschewandhängeschild",
  "block.minecraft.cherry_wall_sign": "Kirschewandschild",
  "block.minecraft.cherry_wood": "Girschholz",
  "block.minecraft.chest": "Druhe",
  "block.minecraft.chipped_anvil": "Angeschlachnorr Ambuss",
  "block.minecraft.chiseled_bookshelf": "Gemeißeltes Bücherschaff",
  "block.minecraft.chiseled_copper": "Gemeißeldes Gupforr",
  "block.minecraft.chiseled_deepslate": "Gemeißeldorr Diefnschieforr",
  "block.minecraft.chiseled_nether_bricks": "Gemeißelde Netherzieschl",
  "block.minecraft.chiseled_polished_blackstone": "Gemeißeldorr bolierdorr Schworzschdeen",
  "block.minecraft.chiseled_quartz_block": "Gemeißeldorr Quarzblogg",
  "block.minecraft.chiseled_red_sandstone": "Gemeißeldorr rodorr Sandschdeen",
  "block.minecraft.chiseled_resin_bricks": "Gemeißelde Harzzieschl",
  "block.minecraft.chiseled_sandstone": "Gemeißeldorr Sandschdeen",
  "block.minecraft.chiseled_stone_bricks": "Gemeißeldorr Schdeenzieschl",
  "block.minecraft.chiseled_tuff": "Gemeißeldorr Duff",
  "block.minecraft.chiseled_tuff_bricks": "Gemeißelde Duffschdeenzieschl",
  "block.minecraft.chorus_flower": "Chorusblüde",
  "block.minecraft.chorus_plant": "Choruspflanze",
  "block.minecraft.clay": "Don",
  "block.minecraft.closed_eyeblossom": "Geschlossene Ochenblüde",
  "block.minecraft.coal_block": "Gohleblogg",
  "block.minecraft.coal_ore": "Schdeengohle",
  "block.minecraft.coarse_dirt": "Grobe Ährde",
  "block.minecraft.cobbled_deepslate": "Bruchdiefnschieforr",
  "block.minecraft.cobbled_deepslate_slab": "Bruchdiefnschieforrschdufe",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchdiefnschieforrdrebbe",
  "block.minecraft.cobbled_deepslate_wall": "Bruchdiefnschieforrmauor",
  "block.minecraft.cobblestone": "Bruchschdeen",
  "block.minecraft.cobblestone_slab": "Bruchschdeenschdufe",
  "block.minecraft.cobblestone_stairs": "Bruchschdeendrebbe",
  "block.minecraft.cobblestone_wall": "Bruchschdeenmauor",
  "block.minecraft.cobweb": "Schbinnnädds",
  "block.minecraft.cocoa": "Gaggau",
  "block.minecraft.command_block": "Befählsblogg",
  "block.minecraft.comparator": "Redstone-Gombaradorr",
  "block.minecraft.composter": "Gomboschdorr",
  "block.minecraft.conduit": "Aquisadorr",
  "block.minecraft.copper_bars": "Gupforrgidder",
  "block.minecraft.copper_block": "Gupforrblogg",
  "block.minecraft.copper_bulb": "Gupforrleuchde",
  "block.minecraft.copper_chain": "Gupforrkedde",
  "block.minecraft.copper_chest": "Gupforrdruhe",
  "block.minecraft.copper_door": "Gupforrdür",
  "block.minecraft.copper_golem_statue": "Gupforrgolemmännl",
  "block.minecraft.copper_grate": "Gupforrrost",
  "block.minecraft.copper_lantern": "Gewachsde Gupforrladerne",
  "block.minecraft.copper_ore": "Gupforrärds",
  "block.minecraft.copper_torch": "Gupforrfaggl",
  "block.minecraft.copper_trapdoor": "Gupforrfalldiere",
  "block.minecraft.copper_wall_torch": "Gupforrwandfaggl",
  "block.minecraft.cornflower": "Gornblume",
  "block.minecraft.cracked_deepslate_bricks": "Riss’sche Diefnschieforrzieschl",
  "block.minecraft.cracked_deepslate_tiles": "Riss’sche Diefnschieforrfliesn",
  "block.minecraft.cracked_nether_bricks": "Riss’sche Netherzieschl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Riss’sche bolierde Schworzschdeenzieschl",
  "block.minecraft.cracked_stone_bricks": "Riss’sche Schdeenzieschl",
  "block.minecraft.crafter": "Werger",
  "block.minecraft.crafting_table": "Wergbang",
  "block.minecraft.creaking_heart": "Gnarzherz",
  "block.minecraft.creeper_head": "Creepernischl",
  "block.minecraft.creeper_wall_head": "Creeper-Wandnischl",
  "block.minecraft.crimson_button": "Garmesingnopp",
  "block.minecraft.crimson_door": "Garmesindiere",
  "block.minecraft.crimson_fence": "Garmesinzaun",
  "block.minecraft.crimson_fence_gate": "Garmesinzaundorr",
  "block.minecraft.crimson_fungus": "Garmesinbilz",
  "block.minecraft.crimson_hanging_sign": "Garmesinhängeschüld",
  "block.minecraft.crimson_hyphae": "Garmesinhyphn",
  "block.minecraft.crimson_nylium": "Garmesin-Nädsl",
  "block.minecraft.crimson_planks": "Garmesinbreddorr",
  "block.minecraft.crimson_pressure_plate": "Garmesindruggbladde",
  "block.minecraft.crimson_roots": "Garmesinwurdsln",
  "block.minecraft.crimson_shelf": "Garmesinregal",
  "block.minecraft.crimson_sign": "Garmesinschüld",
  "block.minecraft.crimson_slab": "Garmesinschdufe",
  "block.minecraft.crimson_stairs": "Garmesindrebbe",
  "block.minecraft.crimson_stem": "Garmesinschdiel",
  "block.minecraft.crimson_trapdoor": "Garmesinfalldiere",
  "block.minecraft.crimson_wall_hanging_sign": "Garmesinwandhängeschüld",
  "block.minecraft.crimson_wall_sign": "Garmesinwandschüld",
  "block.minecraft.crying_obsidian": "Ninglndorr Obsidian",
  "block.minecraft.cut_copper": "Geschniddnorr Gupforrblogg",
  "block.minecraft.cut_copper_slab": "Geschniddne Gupforrschdufe",
  "block.minecraft.cut_copper_stairs": "Geschniddne Gupforrdrebbe",
  "block.minecraft.cut_red_sandstone": "Geschniddnorr rodorr Sandschdeen",
  "block.minecraft.cut_red_sandstone_slab": "Geschniddne rode Sandschdeenschdufe",
  "block.minecraft.cut_sandstone": "Geschniddnorr Sandschdeen",
  "block.minecraft.cut_sandstone_slab": "Geschniddne Sandschdeenschdufe",
  "block.minecraft.cyan_banner": "Dürgises Bannorr",
  "block.minecraft.cyan_bed": "Dürgises Bädde",
  "block.minecraft.cyan_candle": "Dürgise Gerdse",
  "block.minecraft.cyan_candle_cake": "Guchn mid dürgisorr Gerdse",
  "block.minecraft.cyan_carpet": "Dürgisorr Täppsch",
  "block.minecraft.cyan_concrete": "Dürgisorr Bedong",
  "block.minecraft.cyan_concrete_powder": "Dürgisorr Droggnbedong",
  "block.minecraft.cyan_glazed_terracotta": "Dürgise glasierde Geramigg",
  "block.minecraft.cyan_shulker_box": "Dürgise Shulker-Gissde",
  "block.minecraft.cyan_stained_glass": "Dürgises Glas",
  "block.minecraft.cyan_stained_glass_pane": "Dürgise Glasscheebe",
  "block.minecraft.cyan_terracotta": "Dürgise Geramigg",
  "block.minecraft.cyan_wool": "Dürgise Wolle",
  "block.minecraft.damaged_anvil": "Beschädigdorr Ambuss",
  "block.minecraft.dandelion": "Leewnzohn",
  "block.minecraft.dark_oak_button": "Schworzeischnhulzgnopp",
  "block.minecraft.dark_oak_door": "Schworzeischnhulzdiere",
  "block.minecraft.dark_oak_fence": "Schworzeischnhulzzaun",
  "block.minecraft.dark_oak_fence_gate": "Schworzeischnhulzzaundorr",
  "block.minecraft.dark_oak_hanging_sign": "Schworzeischnhulzhängeschüld",
  "block.minecraft.dark_oak_leaves": "Schworzeischnlaub",
  "block.minecraft.dark_oak_log": "Schworzeischnschdamm",
  "block.minecraft.dark_oak_planks": "Schworzeischnhulzbreddorr",
  "block.minecraft.dark_oak_pressure_plate": "Schworzeischnhulzdruggbladde",
  "block.minecraft.dark_oak_sapling": "Schworzeischnseddsling",
  "block.minecraft.dark_oak_shelf": "Schworzeischnholzregal",
  "block.minecraft.dark_oak_sign": "Schworzeischnhulzschüld",
  "block.minecraft.dark_oak_slab": "Schworzeischnhulzschdufe",
  "block.minecraft.dark_oak_stairs": "Schworzeischnhulzdrebbe",
  "block.minecraft.dark_oak_trapdoor": "Schworzeischnhulzfalldiere",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schworzeischnhulzwandhängeschüld",
  "block.minecraft.dark_oak_wall_sign": "Schworzeischnhulzwandschüld",
  "block.minecraft.dark_oak_wood": "Schworzeischnhulz",
  "block.minecraft.dark_prismarine": "Dunglorr Brismarin",
  "block.minecraft.dark_prismarine_slab": "Dungle Brismarinschdufe",
  "block.minecraft.dark_prismarine_stairs": "Dungle Brismarindrebbe",
  "block.minecraft.daylight_detector": "Daacheslischdsensor",
  "block.minecraft.dead_brain_coral": "Abgeschdorbne Hirngoralle",
  "block.minecraft.dead_brain_coral_block": "Abgeschdorbnorr Hirngorallnblogg",
  "block.minecraft.dead_brain_coral_fan": "Abgeschdorbnorr Hirngorallnfäschorr",
  "block.minecraft.dead_brain_coral_wall_fan": "Abgeschdorbnorr Hirngorallnwandfäschorr",
  "block.minecraft.dead_bubble_coral": "Abgeschdorbne Blasngoralle",
  "block.minecraft.dead_bubble_coral_block": "Abgeschdorbnorr Blasngorallnblogg",
  "block.minecraft.dead_bubble_coral_fan": "Abgeschdorbnorr Blasngorallnfäschorr",
  "block.minecraft.dead_bubble_coral_wall_fan": "Abgeschdorbnorr Blasngorallnwandfäschorr",
  "block.minecraft.dead_bush": "Dodorr Busch",
  "block.minecraft.dead_fire_coral": "Abgeschdorbne Feuorrgoralle",
  "block.minecraft.dead_fire_coral_block": "Abgeschdorbnorr Feuorrgorallnblogg",
  "block.minecraft.dead_fire_coral_fan": "Abgeschdorbnorr Feuorrgorallnfäschorr",
  "block.minecraft.dead_fire_coral_wall_fan": "Abgeschdorbnorr Feuorrgorallnwandfäschorr",
  "block.minecraft.dead_horn_coral": "Abgeschdorbne Geweihgoralle",
  "block.minecraft.dead_horn_coral_block": "Abgeschdorbnorr Geweihgorallnblogg",
  "block.minecraft.dead_horn_coral_fan": "Abgeschdorbnorr Geweihgorallnfäschorr",
  "block.minecraft.dead_horn_coral_wall_fan": "Abgeschdorbnorr Geweihgorallnwandfäschorr",
  "block.minecraft.dead_tube_coral": "Abgeschdorbne Orschlgoralle",
  "block.minecraft.dead_tube_coral_block": "Abgeschdorbnorr Orschlgorallnblogg",
  "block.minecraft.dead_tube_coral_fan": "Abgeschdorbnorr Orschlgorallnfäschorr",
  "block.minecraft.dead_tube_coral_wall_fan": "Abgeschdorbnorr Orschlgorallnwandfäschorr",
  "block.minecraft.decorated_pot": "Vorzierder Grug",
  "block.minecraft.deepslate": "Diefnschieforr",
  "block.minecraft.deepslate_brick_slab": "Diefnschieforrzieschlschdufe",
  "block.minecraft.deepslate_brick_stairs": "Diefnschieforrzieschldrebbe",
  "block.minecraft.deepslate_brick_wall": "Diefnschieforrzieschlmauor",
  "block.minecraft.deepslate_bricks": "Diefnschieforrzieschl",
  "block.minecraft.deepslate_coal_ore": "Diefnschieforr-Schdeengohle",
  "block.minecraft.deepslate_copper_ore": "Diefnschieforr-Gupforrärds",
  "block.minecraft.deepslate_diamond_ore": "Diefnschieforr-Diamandärds",
  "block.minecraft.deepslate_emerald_ore": "Diefnschieforr-Smaragdärds",
  "block.minecraft.deepslate_gold_ore": "Diefnschieforr-Goldärds",
  "block.minecraft.deepslate_iron_ore": "Diefnschieforr-Eisnärds",
  "block.minecraft.deepslate_lapis_ore": "Diefnschieforr-Labisladsuliärds",
  "block.minecraft.deepslate_redstone_ore": "Diefnschieforr-Redstone-Ärds",
  "block.minecraft.deepslate_tile_slab": "Diefnschieforrfliesnschdufe",
  "block.minecraft.deepslate_tile_stairs": "Diefnschieforrfliesndrebbe",
  "block.minecraft.deepslate_tile_wall": "Diefnschieforrfliesnmauor",
  "block.minecraft.deepslate_tiles": "Diefnschieforrfliesn",
  "block.minecraft.detector_rail": "Sensorschiene",
  "block.minecraft.diamond_block": "Diamandblogg",
  "block.minecraft.diamond_ore": "Diamandärds",
  "block.minecraft.diorite": "Diorid",
  "block.minecraft.diorite_slab": "Dioridschdufe",
  "block.minecraft.diorite_stairs": "Dioriddrebbe",
  "block.minecraft.diorite_wall": "Dioridmauor",
  "block.minecraft.dirt": "Ährde",
  "block.minecraft.dirt_path": "Dramblpfad",
  "block.minecraft.dispenser": "Werforr",
  "block.minecraft.dragon_egg": "Drachnei",
  "block.minecraft.dragon_head": "Drachnnischl",
  "block.minecraft.dragon_wall_head": "Drachn-Wandnischl",
  "block.minecraft.dried_ghast": "Därrer Ghast",
  "block.minecraft.dried_kelp_block": "Gedroggnedorr Seedangblogg",
  "block.minecraft.dripstone_block": "Drobbschdeenblogg",
  "block.minecraft.dropper": "Schbendorr",
  "block.minecraft.emerald_block": "Smaragdblogg",
  "block.minecraft.emerald_ore": "Smaragdärds",
  "block.minecraft.enchanting_table": "Zaubordisch",
  "block.minecraft.end_gateway": "Enddransidbordal",
  "block.minecraft.end_portal": "Endbordal",
  "block.minecraft.end_portal_frame": "Endbordalrahm",
  "block.minecraft.end_rod": "Endschdab",
  "block.minecraft.end_stone": "Endschdeen",
  "block.minecraft.end_stone_brick_slab": "Endschdeenzieschlschdufe",
  "block.minecraft.end_stone_brick_stairs": "Endschdeenzieschldrebbe",
  "block.minecraft.end_stone_brick_wall": "Endschdeenzieschlmauor",
  "block.minecraft.end_stone_bricks": "Endschdeenzieschl",
  "block.minecraft.ender_chest": "Enderdruhe",
  "block.minecraft.exposed_chiseled_copper": "Angeloofner gemeißelder Gupforrblogg",
  "block.minecraft.exposed_copper": "Angeloofnorr Gupforrblogg",
  "block.minecraft.exposed_copper_bars": "Angeloofne Gupforrgidder",
  "block.minecraft.exposed_copper_bulb": "Angeloofne Gupforrleuchde",
  "block.minecraft.exposed_copper_chain": "Angeloofne Gupforrkedde",
  "block.minecraft.exposed_copper_chest": "Angeloofne Gupforrkisde",
  "block.minecraft.exposed_copper_door": "Angeloofne Gupforrdür",
  "block.minecraft.exposed_copper_golem_statue": "Angeloofnes Gupforrgolemmännl",
  "block.minecraft.exposed_copper_grate": "Angeloofner Gupforrrosd",
  "block.minecraft.exposed_copper_lantern": "Angeloofne Gupforrladerne",
  "block.minecraft.exposed_copper_trapdoor": "Blange Gupforrfalldiere",
  "block.minecraft.exposed_cut_copper": "Blangorr geschniddnorr Gupforrblogg",
  "block.minecraft.exposed_cut_copper_slab": "Blange geschniddne Gupforrschdufe",
  "block.minecraft.exposed_cut_copper_stairs": "Blange geschniddne Gupforrdrebbe",
  "block.minecraft.exposed_lightning_rod": "Angeloofner Blitzableider",
  "block.minecraft.farmland": "Aggorbodn",
  "block.minecraft.fern": "Farn",
  "block.minecraft.fire": "Feuorr",
  "block.minecraft.fire_coral": "Feuorrgoralle",
  "block.minecraft.fire_coral_block": "Feuorrgorallnblogg",
  "block.minecraft.fire_coral_fan": "Feuorrgorallnfäschorr",
  "block.minecraft.fire_coral_wall_fan": "Feuorrgorallnwandfäschorr",
  "block.minecraft.firefly_bush": "Glühwürmlbusch",
  "block.minecraft.fletching_table": "Bochnordisch",
  "block.minecraft.flower_pot": "Bluhmdobb",
  "block.minecraft.flowering_azalea": "Blühnde Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blühndes Azaleenlaub",
  "block.minecraft.frogspawn": "Fruschlaich",
  "block.minecraft.frosted_ice": "Brüschiges Eis",
  "block.minecraft.furnace": "Ofn",
  "block.minecraft.gilded_blackstone": "Golddurschzochnorr Schworzschdeen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasscheebe",
  "block.minecraft.glow_lichen": "Leuschdfleschde",
  "block.minecraft.glowstone": "Leuschdschdeen",
  "block.minecraft.gold_block": "Goldblogg",
  "block.minecraft.gold_ore": "Goldärds",
  "block.minecraft.golden_dandelion": "Goldener Löwenzahn",
  "block.minecraft.granite": "Granid",
  "block.minecraft.granite_slab": "Granidschdufe",
  "block.minecraft.granite_stairs": "Graniddrebbe",
  "block.minecraft.granite_wall": "Granidmauor",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblogg",
  "block.minecraft.gravel": "Gies",
  "block.minecraft.gray_banner": "Graues Bannorr",
  "block.minecraft.gray_bed": "Graues Bädde",
  "block.minecraft.gray_candle": "Graue Gerdse",
  "block.minecraft.gray_candle_cake": "Guchn mid grauorr Gerdse",
  "block.minecraft.gray_carpet": "Grauorr Täppsch",
  "block.minecraft.gray_concrete": "Grauorr Bedong",
  "block.minecraft.gray_concrete_powder": "Grauorr Droggnbedong",
  "block.minecraft.gray_glazed_terracotta": "Graue glasierde Geramigg",
  "block.minecraft.gray_shulker_box": "Graue Shulker-Gissde",
  "block.minecraft.gray_stained_glass": "Graues Glas",
  "block.minecraft.gray_stained_glass_pane": "Graue Glasscheebe",
  "block.minecraft.gray_terracotta": "Graue Geramigg",
  "block.minecraft.gray_wool": "Graue Wolle",
  "block.minecraft.green_banner": "Grienes Bannorr",
  "block.minecraft.green_bed": "Grienes Bädde",
  "block.minecraft.green_candle": "Griene Gerdse",
  "block.minecraft.green_candle_cake": "Guchn mid grienorr Gerdse",
  "block.minecraft.green_carpet": "Grünorr Täppsch",
  "block.minecraft.green_concrete": "Grienorr Bedong",
  "block.minecraft.green_concrete_powder": "Grienorr Droggnbedong",
  "block.minecraft.green_glazed_terracotta": "Griene glasierde Geramigg",
  "block.minecraft.green_shulker_box": "Griene Shulker-Gissde",
  "block.minecraft.green_stained_glass": "Grienes Glas",
  "block.minecraft.green_stained_glass_pane": "Griene Glasscheebe",
  "block.minecraft.green_terracotta": "Griene Geramigg",
  "block.minecraft.green_wool": "Griene Wolle",
  "block.minecraft.grindstone": "Schleefschdeen",
  "block.minecraft.hanging_roots": "Hängewurdsln",
  "block.minecraft.hay_block": "Schdrohballn",
  "block.minecraft.heavy_core": "Schwärorr Kärn",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwäschebladde",
  "block.minecraft.honey_block": "Honischblogg",
  "block.minecraft.honeycomb_block": "Honischwabnblogg",
  "block.minecraft.hopper": "Drischdorr",
  "block.minecraft.horn_coral": "Geweihgoralle",
  "block.minecraft.horn_coral_block": "Geweihgorallnblogg",
  "block.minecraft.horn_coral_fan": "Geweihgorallnfäschorr",
  "block.minecraft.horn_coral_wall_fan": "Geweihgorallnwandfäschorr",
  "block.minecraft.ice": "Eis",
  "block.minecraft.infested_chiseled_stone_bricks": "Befallne gemeißelde Schdeenzieschl",
  "block.minecraft.infested_cobblestone": "Befallnorr Bruchschdeen",
  "block.minecraft.infested_cracked_stone_bricks": "Befallnorr riss’schorr Schdeenzieschl",
  "block.minecraft.infested_deepslate": "Befallnorr Diefnschieforr",
  "block.minecraft.infested_mossy_stone_bricks": "Befallne bemoosde Schdeenzieschl",
  "block.minecraft.infested_stone": "Befallnorr Schdeen",
  "block.minecraft.infested_stone_bricks": "Befallne Schdeenzieschl",
  "block.minecraft.iron_bars": "Eisngiddor",
  "block.minecraft.iron_block": "Eisnblogg",
  "block.minecraft.iron_chain": "Eisenkedde",
  "block.minecraft.iron_door": "Eisndiere",
  "block.minecraft.iron_ore": "Eisnärds",
  "block.minecraft.iron_trapdoor": "Eisnfalldiere",
  "block.minecraft.jack_o_lantern": "Gürbisladderne",
  "block.minecraft.jigsaw": "Vorrbundblogg",
  "block.minecraft.jukebox": "Bladdnschbielorr",
  "block.minecraft.jungle_button": "Drobnhulzgnopp",
  "block.minecraft.jungle_door": "Drobnhulzdiere",
  "block.minecraft.jungle_fence": "Drobnhulzzaun",
  "block.minecraft.jungle_fence_gate": "Drobnhulzzaundorr",
  "block.minecraft.jungle_hanging_sign": "Drobnhulzhängeschüld",
  "block.minecraft.jungle_leaves": "Drobnbohmlaub",
  "block.minecraft.jungle_log": "Drobnbohmschdamm",
  "block.minecraft.jungle_planks": "Drobnhulzbreddorr",
  "block.minecraft.jungle_pressure_plate": "Drobnhulzdruggbladde",
  "block.minecraft.jungle_sapling": "Drobnbohmseddsling",
  "block.minecraft.jungle_shelf": "Dropenholzregal",
  "block.minecraft.jungle_sign": "Drobnhulzschüld",
  "block.minecraft.jungle_slab": "Drobnhulzschdufe",
  "block.minecraft.jungle_stairs": "Drobnhulzdrebbe",
  "block.minecraft.jungle_trapdoor": "Drobnhulzfalldiere",
  "block.minecraft.jungle_wall_hanging_sign": "Drobnhulzwandhängeschüld",
  "block.minecraft.jungle_wall_sign": "Drobnhulzwandschüld",
  "block.minecraft.jungle_wood": "Drobnhulz",
  "block.minecraft.kelp": "Seedang",
  "block.minecraft.kelp_plant": "Seedangschdängl",
  "block.minecraft.ladder": "Leidorr",
  "block.minecraft.lantern": "Ladderne",
  "block.minecraft.lapis_block": "Labisladsuliblogg",
  "block.minecraft.lapis_ore": "Labisladsuliärds",
  "block.minecraft.large_amethyst_bud": "Große Amethystgnosbe",
  "block.minecraft.large_fern": "Großorr Farn",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavagessl",
  "block.minecraft.leaf_litter": "Laubhoofn",
  "block.minecraft.lectern": "Lesebuld",
  "block.minecraft.lever": "Hebl",
  "block.minecraft.light": "Lischdblogg",
  "block.minecraft.light_blue_banner": "Hellblaues Bannorr",
  "block.minecraft.light_blue_bed": "Hellblaues Bädde",
  "block.minecraft.light_blue_candle": "Hellblaue Gerdse",
  "block.minecraft.light_blue_candle_cake": "Guchn mid hellblauorr Gerdse",
  "block.minecraft.light_blue_carpet": "Hellblauorr Täppsch",
  "block.minecraft.light_blue_concrete": "Hellblauorr Bedong",
  "block.minecraft.light_blue_concrete_powder": "Hellblauorr Droggnbedong",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblaue glasierde Geramigg",
  "block.minecraft.light_blue_shulker_box": "Hellblaue Shulker-Gissde",
  "block.minecraft.light_blue_stained_glass": "Hellblaues Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblaue Glasscheebe",
  "block.minecraft.light_blue_terracotta": "Hellblaue Geramigg",
  "block.minecraft.light_blue_wool": "Hellblaue Wolle",
  "block.minecraft.light_gray_banner": "Hellgraues Bannorr",
  "block.minecraft.light_gray_bed": "Hellgraues Bädde",
  "block.minecraft.light_gray_candle": "Hellgraue Gerdse",
  "block.minecraft.light_gray_candle_cake": "Guchn mid hellgrauorr Gerdse",
  "block.minecraft.light_gray_carpet": "Hellgrauorr Täppsch",
  "block.minecraft.light_gray_concrete": "Hellgrauorr Bedong",
  "block.minecraft.light_gray_concrete_powder": "Hellgrauorr Droggnbedong",
  "block.minecraft.light_gray_glazed_terracotta": "Hellgraue glasierde Geramigg",
  "block.minecraft.light_gray_shulker_box": "Hellgraue Shulker-Gissde",
  "block.minecraft.light_gray_stained_glass": "Hellgraues Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgraue Glasscheebe",
  "block.minecraft.light_gray_terracotta": "Hellgraue Geramigg",
  "block.minecraft.light_gray_wool": "Hellgraue Wolle",
  "block.minecraft.light_weighted_pressure_plate": "Feinwäschebladde",
  "block.minecraft.lightning_rod": "Bliddsableidorr",
  "block.minecraft.lilac": "Fliedor",
  "block.minecraft.lily_of_the_valley": "Maiglöggschn",
  "block.minecraft.lily_pad": "Seerosnbladd",
  "block.minecraft.lime_banner": "Hellgrienes Bannorr",
  "block.minecraft.lime_bed": "Hellgrienes Bädde",
  "block.minecraft.lime_candle": "Hellgriene Gerdse",
  "block.minecraft.lime_candle_cake": "Guchn mid hellgrienorr Gerdse",
  "block.minecraft.lime_carpet": "Hellgrienorr Täppsch",
  "block.minecraft.lime_concrete": "Hellgrienorr Bedong",
  "block.minecraft.lime_concrete_powder": "Hellgrienorr Droggnbedong",
  "block.minecraft.lime_glazed_terracotta": "Hellgriene glasierde Geramigg",
  "block.minecraft.lime_shulker_box": "Hellgriene Shulker-Gissde",
  "block.minecraft.lime_stained_glass": "Hellgrienes Glas",
  "block.minecraft.lime_stained_glass_pane": "Hellgriene Glasscheebe",
  "block.minecraft.lime_terracotta": "Hellgriene Geramigg",
  "block.minecraft.lime_wool": "Hellgriene Wolle",
  "block.minecraft.lodestone": "Leedschdeen",
  "block.minecraft.loom": "Wäbbschduhl",
  "block.minecraft.magenta_banner": "Magenda Bannorr",
  "block.minecraft.magenta_bed": "Magenda Bädde",
  "block.minecraft.magenta_candle": "Magenda Gerdse",
  "block.minecraft.magenta_candle_cake": "Guchn mid magenda Gerdse",
  "block.minecraft.magenta_carpet": "Magenda Täppsch",
  "block.minecraft.magenta_concrete": "Magenda Bedong",
  "block.minecraft.magenta_concrete_powder": "Magenda Droggnbedong",
  "block.minecraft.magenta_glazed_terracotta": "Magenda glasierde Geramigg",
  "block.minecraft.magenta_shulker_box": "Magenda Shulker-Gissde",
  "block.minecraft.magenta_stained_glass": "Magenda Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenda Glasscheebe",
  "block.minecraft.magenta_terracotta": "Magenda Geramigg",
  "block.minecraft.magenta_wool": "Magenda Wolle",
  "block.minecraft.magma_block": "Magmablogg",
  "block.minecraft.mangrove_button": "Mangrovnhulzgnopp",
  "block.minecraft.mangrove_door": "Mangrovnhulzdiere",
  "block.minecraft.mangrove_fence": "Mangrovnhulzzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovnhulzzaundorr",
  "block.minecraft.mangrove_hanging_sign": "Mangrovnhulzhängeschüld",
  "block.minecraft.mangrove_leaves": "Mangrovnlaub",
  "block.minecraft.mangrove_log": "Mangrovnschdamm",
  "block.minecraft.mangrove_planks": "Mangrovnhulzbreddorr",
  "block.minecraft.mangrove_pressure_plate": "Mangrovnhulzdruggbladde",
  "block.minecraft.mangrove_propagule": "Mangrovn-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovnwurdsln",
  "block.minecraft.mangrove_shelf": "Mangrovnregal",
  "block.minecraft.mangrove_sign": "Mangrovnhulzschüld",
  "block.minecraft.mangrove_slab": "Mangrovnhulzschdufe",
  "block.minecraft.mangrove_stairs": "Mangrovnhulzdrebbe",
  "block.minecraft.mangrove_trapdoor": "Mangrovnhulzfalldiere",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovnhulzwandhängeschüld",
  "block.minecraft.mangrove_wall_sign": "Mangrovnhulzwandschüld",
  "block.minecraft.mangrove_wood": "Mangrovnhulz",
  "block.minecraft.medium_amethyst_bud": "Mittlorre Amethystgnosbe",
  "block.minecraft.melon": "Melone",
  "block.minecraft.melon_stem": "Melonpflanze",
  "block.minecraft.moss_block": "Moosblogg",
  "block.minecraft.moss_carpet": "Moostäppsch",
  "block.minecraft.mossy_cobblestone": "Bemoosdorr Bruchschdeen",
  "block.minecraft.mossy_cobblestone_slab": "Bemoosde Bruchschdeenschdufe",
  "block.minecraft.mossy_cobblestone_stairs": "Bemoosde Bruchschdeendrebbe",
  "block.minecraft.mossy_cobblestone_wall": "Bemoosde Bruchschdeenmauor",
  "block.minecraft.mossy_stone_brick_slab": "Bemoosde Schdeenzieschlschdufe",
  "block.minecraft.mossy_stone_brick_stairs": "Bemoosde Schdeenzieschldrebbe",
  "block.minecraft.mossy_stone_brick_wall": "Bemoosde Schdeenzieschlmauor",
  "block.minecraft.mossy_stone_bricks": "Bemoosde Schdeenzieschl",
  "block.minecraft.moving_piston": "Beweeschdorr Blogg",
  "block.minecraft.mud": "Schlamm",
  "block.minecraft.mud_brick_slab": "Schlammzieschlschdufe",
  "block.minecraft.mud_brick_stairs": "Schlammzieschldrebbe",
  "block.minecraft.mud_brick_wall": "Schlammzieschlmauorr",
  "block.minecraft.mud_bricks": "Schlammzieschl",
  "block.minecraft.muddy_mangrove_roots": "Schlammsche Mangrovnwurdsln",
  "block.minecraft.mushroom_stem": "Bilzschdiel",
  "block.minecraft.mycelium": "Mydsäl",
  "block.minecraft.nether_brick_fence": "Netherzieschlzaun",
  "block.minecraft.nether_brick_slab": "Netherzieschlschdufe",
  "block.minecraft.nether_brick_stairs": "Netherzieschldrebbe",
  "block.minecraft.nether_brick_wall": "Netherzieschlmauor",
  "block.minecraft.nether_bricks": "Netherzieschl",
  "block.minecraft.nether_gold_ore": "Nethergoldärds",
  "block.minecraft.nether_portal": "Netherbordal",
  "block.minecraft.nether_quartz_ore": "Netherquarzärds",
  "block.minecraft.nether_sprouts": "Netherschbrossn",
  "block.minecraft.nether_wart": "Netherwarzn",
  "block.minecraft.nether_wart_block": "Netherwarznblogg",
  "block.minecraft.netherite_block": "Nädderidblogg",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noodnblogg",
  "block.minecraft.oak_button": "Eischnhulzgnopp",
  "block.minecraft.oak_door": "Eischnhulzdiere",
  "block.minecraft.oak_fence": "Eischnhulzzaun",
  "block.minecraft.oak_fence_gate": "Eischnhulzzaundorr",
  "block.minecraft.oak_hanging_sign": "Eischnhulzhängeschüld",
  "block.minecraft.oak_leaves": "Eischnlaub",
  "block.minecraft.oak_log": "Eischnschdamm",
  "block.minecraft.oak_planks": "Eischnhulzbreddorr",
  "block.minecraft.oak_pressure_plate": "Eischnhulzdruggbladde",
  "block.minecraft.oak_sapling": "Eischnseddsling",
  "block.minecraft.oak_shelf": "Eichnholzregal",
  "block.minecraft.oak_sign": "Eischnhulzschüld",
  "block.minecraft.oak_slab": "Eischnhulzschdufe",
  "block.minecraft.oak_stairs": "Eischnhulzdrebbe",
  "block.minecraft.oak_trapdoor": "Eischnhulzfalldiere",
  "block.minecraft.oak_wall_hanging_sign": "Eischnhulzwandhängeschüld",
  "block.minecraft.oak_wall_sign": "Eischnhulzwandschüld",
  "block.minecraft.oak_wood": "Eischnhulz",
  "block.minecraft.observer": "Beobachdor",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Oggorrnes Fruschlichd",
  "block.minecraft.ominous_banner": "Unheilvolles Bannorr",
  "block.minecraft.open_eyeblossom": "Offne Ochenblüde",
  "block.minecraft.orange_banner": "Orangsches Bannorr",
  "block.minecraft.orange_bed": "Orangsches Bädde",
  "block.minecraft.orange_candle": "Orangsche Gerdse",
  "block.minecraft.orange_candle_cake": "Guchn mid orangschorr Gerdse",
  "block.minecraft.orange_carpet": "Orangschnorr Täppsch",
  "block.minecraft.orange_concrete": "Orangschorr Bedong",
  "block.minecraft.orange_concrete_powder": "Orangschorr Droggnbedong",
  "block.minecraft.orange_glazed_terracotta": "Orangsche glasierde Geramigg",
  "block.minecraft.orange_shulker_box": "Orangschne Shulker-Gissde",
  "block.minecraft.orange_stained_glass": "Orangsches Glas",
  "block.minecraft.orange_stained_glass_pane": "Orangsche Glasscheebe",
  "block.minecraft.orange_terracotta": "Orangschne Geramigg",
  "block.minecraft.orange_tulip": "Orangsche Dulbe",
  "block.minecraft.orange_wool": "Orangsche Wolle",
  "block.minecraft.oxeye_daisy": "Margoride",
  "block.minecraft.oxidized_chiseled_copper": "rostsches gemeißeldes Gupforr",
  "block.minecraft.oxidized_copper": "Oxidierdorr Gupforrblogg",
  "block.minecraft.oxidized_copper_bars": "rostsches Gupforrgidder",
  "block.minecraft.oxidized_copper_bulb": "Oxidierde Gupforrleuchte",
  "block.minecraft.oxidized_copper_chain": "rostsche Gupferkedde",
  "block.minecraft.oxidized_copper_chest": "rostsche Gupforrdruhe",
  "block.minecraft.oxidized_copper_door": "rostsche Gupforrdür",
  "block.minecraft.oxidized_copper_golem_statue": "rostsches Gupforrgolemmännl",
  "block.minecraft.oxidized_copper_grate": "rostscher Gupforrrost",
  "block.minecraft.oxidized_copper_lantern": "rostsche Gupforrleuchte",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidierde Gupforrfalldiere",
  "block.minecraft.oxidized_cut_copper": "Oxidierdorr geschniddnorr Gupforrblogg",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidierde geschniddne Gupforrblogg",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidierde geschniddne Gupforrdrebbe",
  "block.minecraft.oxidized_lightning_rod": "rostscher Blitzableider",
  "block.minecraft.packed_ice": "Paggeis",
  "block.minecraft.packed_mud": "Fesdorr Schlamm",
  "block.minecraft.pale_hanging_moss": "Baumelndes Blassmoos",
  "block.minecraft.pale_moss_block": "Blassmoosblogg",
  "block.minecraft.pale_moss_carpet": "Blassmoosdeppsch",
  "block.minecraft.pale_oak_button": "Blasseichnholzgnopp",
  "block.minecraft.pale_oak_door": "Blasseichnholzdür",
  "block.minecraft.pale_oak_fence": "Blasseichnholzzaun",
  "block.minecraft.pale_oak_fence_gate": "Blasseichnholzzaundorr",
  "block.minecraft.pale_oak_hanging_sign": "Blasseichnholzhängeschild",
  "block.minecraft.pale_oak_leaves": "Blasseichnlaub",
  "block.minecraft.pale_oak_log": "Blasseichnholzschdamm",
  "block.minecraft.pale_oak_planks": "Blasseichnholzbreddorr",
  "block.minecraft.pale_oak_pressure_plate": "Blasseichnholzdruggbladde",
  "block.minecraft.pale_oak_sapling": "Blasseichnseddsling",
  "block.minecraft.pale_oak_shelf": "Blasseichnholzregal",
  "block.minecraft.pale_oak_sign": "Blasseichnholzschüld",
  "block.minecraft.pale_oak_slab": "Blasseichnholzschdufe",
  "block.minecraft.pale_oak_stairs": "Blasseichnholzdrebbe",
  "block.minecraft.pale_oak_trapdoor": "Blasseichnholzfalldiere",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blasseichnholzhängeschüld",
  "block.minecraft.pale_oak_wall_sign": "Blasseichnholzwandschüld",
  "block.minecraft.pale_oak_wood": "Blasseichnholz",
  "block.minecraft.pearlescent_froglight": "Perlmuddorrnes Fruschlichd",
  "block.minecraft.peony": "Pfingsdrose",
  "block.minecraft.petrified_oak_slab": "Vorschdeinorde Eischnhulzschdufe",
  "block.minecraft.piglin_head": "Piglinnischl",
  "block.minecraft.piglin_wall_head": "Piglin-Wandnischl",
  "block.minecraft.pink_banner": "Pinges Bannorr",
  "block.minecraft.pink_bed": "Pinges Bädde",
  "block.minecraft.pink_candle": "Pinge Gerdse",
  "block.minecraft.pink_candle_cake": "Guchn mid pingorr Gerdse",
  "block.minecraft.pink_carpet": "Rosa Täppsch",
  "block.minecraft.pink_concrete": "Pingorr Bedong",
  "block.minecraft.pink_concrete_powder": "Pingorr Droggnbedong",
  "block.minecraft.pink_glazed_terracotta": "Pinge glasierde Geramigg",
  "block.minecraft.pink_petals": "Rosa Blüdnbläddor",
  "block.minecraft.pink_shulker_box": "Pinge Shulker-Gissde",
  "block.minecraft.pink_stained_glass": "Pinges Glas",
  "block.minecraft.pink_stained_glass_pane": "Pinge Glasscheebe",
  "block.minecraft.pink_terracotta": "Pinge Geramigg",
  "block.minecraft.pink_tulip": "Pinge Dulbe",
  "block.minecraft.pink_wool": "Pinge Wolle",
  "block.minecraft.piston": "Golbn",
  "block.minecraft.piston_head": "Golbngopp",
  "block.minecraft.pitcher_crop": "Gannenfrucht",
  "block.minecraft.pitcher_plant": "Gannenpflanze",
  "block.minecraft.player_head": "Schbielorrnischl",
  "block.minecraft.player_head.named": "Nischl von %s",
  "block.minecraft.player_wall_head": "Schbielorr-Wandnischl",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Schbidsorr Drobbschdeen",
  "block.minecraft.polished_andesite": "Bolierdorr Andesid",
  "block.minecraft.polished_andesite_slab": "Bolierde Andesidschdufe",
  "block.minecraft.polished_andesite_stairs": "Bolierde Andesiddrebbe",
  "block.minecraft.polished_basalt": "Bolierdorr Basald",
  "block.minecraft.polished_blackstone": "Bolierdorr Schworzschdeen",
  "block.minecraft.polished_blackstone_brick_slab": "Bolierde Schworzschdeenzieschlschdufe",
  "block.minecraft.polished_blackstone_brick_stairs": "Bolierde Schworzschdeenzieschldrebbe",
  "block.minecraft.polished_blackstone_brick_wall": "Bolierde Schworzschdeenzieschlmauor",
  "block.minecraft.polished_blackstone_bricks": "Bolierde Schworzschdeenzieschl",
  "block.minecraft.polished_blackstone_button": "Bolierdorr Schworzschdeengnopp",
  "block.minecraft.polished_blackstone_pressure_plate": "Bolierde Schworzschdeendruggbladde",
  "block.minecraft.polished_blackstone_slab": "Bolierde Schworzschdeenschdufe",
  "block.minecraft.polished_blackstone_stairs": "Bolierde Schworzschdeendrebbe",
  "block.minecraft.polished_blackstone_wall": "Bolierde Schworzschdeenmauor",
  "block.minecraft.polished_deepslate": "Bolierdorr Diefnschieforr",
  "block.minecraft.polished_deepslate_slab": "Bolierde Diefnschieforrschdufe",
  "block.minecraft.polished_deepslate_stairs": "Bolierde Diefnschieforrdrebbe",
  "block.minecraft.polished_deepslate_wall": "Bolierde Diefnschieforrmauor",
  "block.minecraft.polished_diorite": "Bolierdorr Diorid",
  "block.minecraft.polished_diorite_slab": "Bolierde Dioridschdufe",
  "block.minecraft.polished_diorite_stairs": "Bolierde Dioriddrebbe",
  "block.minecraft.polished_granite": "Bolierdorr Granid",
  "block.minecraft.polished_granite_slab": "Bolierde Granidschdufe",
  "block.minecraft.polished_granite_stairs": "Bolierde Graniddrebbe",
  "block.minecraft.polished_tuff": "Polierdorr Tuffsteen",
  "block.minecraft.polished_tuff_slab": "Polierte Tuffsteenschdufe",
  "block.minecraft.polished_tuff_stairs": "Polierde Tuffsteendrebbe",
  "block.minecraft.polished_tuff_wall": "Polierde Tuffsteenmauorr",
  "block.minecraft.poppy": "Mohn",
  "block.minecraft.potatoes": "Gardoffln",
  "block.minecraft.potted_acacia_sapling": "Eengedobbdorr Agazienseddsling",
  "block.minecraft.potted_allium": "Eengedobbdorr Schdernlauch",
  "block.minecraft.potted_azalea_bush": "Eengedobbde Azalee",
  "block.minecraft.potted_azure_bluet": "Eengedobbdes Porzellanschdernschn",
  "block.minecraft.potted_bamboo": "Eengedobbdorr Bambus",
  "block.minecraft.potted_birch_sapling": "Eengedobbdorr Bürschnseddsling",
  "block.minecraft.potted_blue_orchid": "Eengedobbde blaue Orchidee",
  "block.minecraft.potted_brown_mushroom": "Eengedobbdorr braunorr Bilz",
  "block.minecraft.potted_cactus": "Eengedobbdorr Gaggdus",
  "block.minecraft.potted_cherry_sapling": "Eingedopfor Girschsetzling",
  "block.minecraft.potted_closed_eyeblossom": "Eingedopfde geschlossne Ochenblüde",
  "block.minecraft.potted_cornflower": "Eengedobbde Gornblume",
  "block.minecraft.potted_crimson_fungus": "Eengedobbdorr Garmesinbilz",
  "block.minecraft.potted_crimson_roots": "Eengedobbde Garmesinwurdsln",
  "block.minecraft.potted_dandelion": "Eengedobbdorr Leewnzohn",
  "block.minecraft.potted_dark_oak_sapling": "Eengedobbdorr Schworzeischnseddsling",
  "block.minecraft.potted_dead_bush": "Eengedobbdorr dodorr Busch",
  "block.minecraft.potted_fern": "Eengedobbdorr Farn",
  "block.minecraft.potted_flowering_azalea_bush": "Eengedobbde blühnde Azalee",
  "block.minecraft.potted_golden_dandelion": "Eingetopfter goldener Löwenzahn",
  "block.minecraft.potted_jungle_sapling": "Eengedobbdorr Drobnseddsling",
  "block.minecraft.potted_lily_of_the_valley": "Eengedobbdes Maiglöggschn",
  "block.minecraft.potted_mangrove_propagule": "Eengedobbdorr Mangrovn-Keimling",
  "block.minecraft.potted_oak_sapling": "Eengedobbdorr Eischnseddsling",
  "block.minecraft.potted_open_eyeblossom": "Eingedopfde offne Ochenblüde",
  "block.minecraft.potted_orange_tulip": "Eengedobbde orangsche Dulbe",
  "block.minecraft.potted_oxeye_daisy": "Eengedobbde Margoride",
  "block.minecraft.potted_pale_oak_sapling": "Eingedopfder Eichnseddsling",
  "block.minecraft.potted_pink_tulip": "Eengedobbde pinge Dulbe",
  "block.minecraft.potted_poppy": "Eengedobbdorr Mohn",
  "block.minecraft.potted_red_mushroom": "Eengedobbdorr rodorr Bilz",
  "block.minecraft.potted_red_tulip": "Eengedobbde rode Dulbe",
  "block.minecraft.potted_spruce_sapling": "Eengedobbdorr Fischdnseddsling",
  "block.minecraft.potted_torchflower": "Eingedopfte Fackllilie",
  "block.minecraft.potted_warped_fungus": "Eengedobbdorr Würrbilz",
  "block.minecraft.potted_warped_roots": "Eengedobbde Würrwurdsln",
  "block.minecraft.potted_white_tulip": "Eengedobbde weeße Dulbe",
  "block.minecraft.potted_wither_rose": "Eengedobbde Wither-Rose",
  "block.minecraft.powder_snow": "Bulvorrschnee",
  "block.minecraft.powder_snow_cauldron": "Bulvorrschneegessl",
  "block.minecraft.powered_rail": "Andriebsschiene",
  "block.minecraft.prismarine": "Brismarin",
  "block.minecraft.prismarine_brick_slab": "Brismarinzieschlschdufe",
  "block.minecraft.prismarine_brick_stairs": "Brismarinzieschldrebbe",
  "block.minecraft.prismarine_bricks": "Brismarinzieschl",
  "block.minecraft.prismarine_slab": "Brismarinschdufe",
  "block.minecraft.prismarine_stairs": "Brismarindrebbe",
  "block.minecraft.prismarine_wall": "Brismarinmauor",
  "block.minecraft.pumpkin": "Gürbis",
  "block.minecraft.pumpkin_stem": "Gürbispflanze",
  "block.minecraft.purple_banner": "Lila Bannorr",
  "block.minecraft.purple_bed": "Lila Bädde",
  "block.minecraft.purple_candle": "Lila Gerdse",
  "block.minecraft.purple_candle_cake": "Guchn mid lila Gerdse",
  "block.minecraft.purple_carpet": "Lila Täppsch",
  "block.minecraft.purple_concrete": "Lila Bedong",
  "block.minecraft.purple_concrete_powder": "Lila Droggnbedong",
  "block.minecraft.purple_glazed_terracotta": "Lila glasierde Geramigg",
  "block.minecraft.purple_shulker_box": "Lila Shulker-Gissde",
  "block.minecraft.purple_stained_glass": "Lila Glas",
  "block.minecraft.purple_stained_glass_pane": "Lila Glasscheebe",
  "block.minecraft.purple_terracotta": "Lila Geramigg",
  "block.minecraft.purple_wool": "Lila Wolle",
  "block.minecraft.purpur_block": "Purpurblogg",
  "block.minecraft.purpur_pillar": "Purpursäule",
  "block.minecraft.purpur_slab": "Purpurschdufe",
  "block.minecraft.purpur_stairs": "Purpurdrebbe",
  "block.minecraft.quartz_block": "Quarzblogg",
  "block.minecraft.quartz_bricks": "Quarzzieschl",
  "block.minecraft.quartz_pillar": "Quarzsäule",
  "block.minecraft.quartz_slab": "Quarzschdufe",
  "block.minecraft.quartz_stairs": "Quarzdrebbe",
  "block.minecraft.rail": "Schiene",
  "block.minecraft.raw_copper_block": "Rohgupforrblogg",
  "block.minecraft.raw_gold_block": "Rohgoldblogg",
  "block.minecraft.raw_iron_block": "Roheisnblogg",
  "block.minecraft.red_banner": "Rodes Bannorr",
  "block.minecraft.red_bed": "Rodes Bädde",
  "block.minecraft.red_candle": "Rode Gerdse",
  "block.minecraft.red_candle_cake": "Guchn mid rodorr Gerdse",
  "block.minecraft.red_carpet": "Rodorr Täppsch",
  "block.minecraft.red_concrete": "Rodorr Bedong",
  "block.minecraft.red_concrete_powder": "Rodorr Droggnbedong",
  "block.minecraft.red_glazed_terracotta": "Rode glasierde Geramigg",
  "block.minecraft.red_mushroom": "Rodorr Bilz",
  "block.minecraft.red_mushroom_block": "Rodorr Bilzblogg",
  "block.minecraft.red_nether_brick_slab": "Rode Netherzieschlschdufe",
  "block.minecraft.red_nether_brick_stairs": "Rode Netherzieschltrebbe",
  "block.minecraft.red_nether_brick_wall": "Rode Netherzieschlmauor",
  "block.minecraft.red_nether_bricks": "Rode Netherzieschl",
  "block.minecraft.red_sand": "Rodorr Sand",
  "block.minecraft.red_sandstone": "Rodorr Sandschdeen",
  "block.minecraft.red_sandstone_slab": "Rode Sandschdeenschdufe",
  "block.minecraft.red_sandstone_stairs": "Rode Sandschdeendrebbe",
  "block.minecraft.red_sandstone_wall": "Rodde Sandschdeenmauor",
  "block.minecraft.red_shulker_box": "Rode Shulker-Gissde",
  "block.minecraft.red_stained_glass": "Rodes Glas",
  "block.minecraft.red_stained_glass_pane": "Rode Glasscheebe",
  "block.minecraft.red_terracotta": "Rode Geramigg",
  "block.minecraft.red_tulip": "Rode Dulbe",
  "block.minecraft.red_wool": "Rode Wolle",
  "block.minecraft.redstone_block": "Redstone-Blogg",
  "block.minecraft.redstone_lamp": "Redstone-Funsl",
  "block.minecraft.redstone_ore": "Redstone-Ärds",
  "block.minecraft.redstone_torch": "Redstone-Faggl",
  "block.minecraft.redstone_wall_torch": "Redstone-Wandfaggl",
  "block.minecraft.redstone_wire": "Redstone-Leidung",
  "block.minecraft.reinforced_deepslate": "Vorrschdärgdorr Diefnschieforr",
  "block.minecraft.repeater": "Redstone-Vorschdärgor",
  "block.minecraft.repeating_command_block": "Wiedorrhol-Befählsblogg",
  "block.minecraft.resin_block": "Harzblogg",
  "block.minecraft.resin_brick_slab": "Harzzieschlschdufe",
  "block.minecraft.resin_brick_stairs": "Harzzieschldrebbe",
  "block.minecraft.resin_brick_wall": "Harzziegelmauer",
  "block.minecraft.resin_bricks": "Harzziegel",
  "block.minecraft.resin_clump": "Harzklumpen",
  "block.minecraft.respawn_anchor": "Seelnangorr",
  "block.minecraft.rooted_dirt": "Wurdslährde",
  "block.minecraft.rose_bush": "Rosnschdrauch",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandschdeen",
  "block.minecraft.sandstone_slab": "Sandschdeenschdufe",
  "block.minecraft.sandstone_stairs": "Sandschdeendrebbe",
  "block.minecraft.sandstone_wall": "Sandschdeenmauor",
  "block.minecraft.scaffolding": "Gerüschd",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Gadalysadorr",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Greischorr",
  "block.minecraft.sculk_vein": "Sculk-Adorr",
  "block.minecraft.sea_lantern": "Seeladderne",
  "block.minecraft.sea_pickle": "Seegurge",
  "block.minecraft.seagrass": "Seegras",
  "block.minecraft.set_spawn": "Wiedorreinschdiegsbungd gesäddsd",
  "block.minecraft.short_dry_grass": "Niedriges Droggnes Geschdrüpp",
  "block.minecraft.short_grass": "Niedriges Gras",
  "block.minecraft.shroomlight": "Bilzlischd",
  "block.minecraft.shulker_box": "Shulker-Gissde",
  "block.minecraft.skeleton_skull": "Schgeleddnischl",
  "block.minecraft.skeleton_wall_skull": "Schgeledd-Wandnischl",
  "block.minecraft.slime_block": "Schleimblogg",
  "block.minecraft.small_amethyst_bud": "Gleene Amethystgnosbe",
  "block.minecraft.small_dripleaf": "Gleenes Drobbbladd",
  "block.minecraft.smithing_table": "Schmiededisch",
  "block.minecraft.smoker": "Räuschoroofn",
  "block.minecraft.smooth_basalt": "Gladdorr Basald",
  "block.minecraft.smooth_quartz": "Gladdorr Quarzblogg",
  "block.minecraft.smooth_quartz_slab": "Gladde Quarzschdufe",
  "block.minecraft.smooth_quartz_stairs": "Gladde Quarzdrebbe",
  "block.minecraft.smooth_red_sandstone": "Gladdorr rodorr Sandschdeen",
  "block.minecraft.smooth_red_sandstone_slab": "Gladde rodde Sandschdeenschdufe",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladde rodde Sandschdeendrebbe",
  "block.minecraft.smooth_sandstone": "Gladdorr Sandschdeen",
  "block.minecraft.smooth_sandstone_slab": "Gladde Sandschdeenschdufe",
  "block.minecraft.smooth_sandstone_stairs": "Gladde Sandschdeendrebbe",
  "block.minecraft.smooth_stone": "Gladdorr Schdeen",
  "block.minecraft.smooth_stone_slab": "Gladde Schdeenschdufe",
  "block.minecraft.sniffer_egg": "Schnüfflor-Ei",
  "block.minecraft.snow": "Schnee",
  "block.minecraft.snow_block": "Schneeblogg",
  "block.minecraft.soul_campfire": "Seelnlagorfeuorr",
  "block.minecraft.soul_fire": "Seelnfeuorr",
  "block.minecraft.soul_lantern": "Seelnladderne",
  "block.minecraft.soul_sand": "Seelnsand",
  "block.minecraft.soul_soil": "Seelnerde",
  "block.minecraft.soul_torch": "Seelnfaggl",
  "block.minecraft.soul_wall_torch": "Seelnwandfaggl",
  "block.minecraft.spawn.not_valid": "Du hasd kee Bedde un keen uffgeladnen Seelnangorr, odorr dei Wiedorreenschdiegsbungd wurde bloggierd",
  "block.minecraft.spawner": "Schbornorr",
  "block.minecraft.spawner.desc1": "Benudze Spawn-Ei:",
  "block.minecraft.spawner.desc2": "Lescht Greadurendyp fest",
  "block.minecraft.sponge": "Schwamm",
  "block.minecraft.spore_blossom": "Schbornblüde",
  "block.minecraft.spruce_button": "Fischdnhulzgnopp",
  "block.minecraft.spruce_door": "Fischdnhulzdiere",
  "block.minecraft.spruce_fence": "Fischdnhulzzaun",
  "block.minecraft.spruce_fence_gate": "Fischdnhulzzaundorr",
  "block.minecraft.spruce_hanging_sign": "Fischdnhulzhängeschüld",
  "block.minecraft.spruce_leaves": "Fischdnnadln",
  "block.minecraft.spruce_log": "Fischdnschdamm",
  "block.minecraft.spruce_planks": "Fischdnhulzbreddorr",
  "block.minecraft.spruce_pressure_plate": "Fischdnhulzdruggbladde",
  "block.minecraft.spruce_sapling": "Fischdnseddsling",
  "block.minecraft.spruce_shelf": "Fichtenholzregal",
  "block.minecraft.spruce_sign": "Fischdnhulzschüld",
  "block.minecraft.spruce_slab": "Fischdnhulzschdufe",
  "block.minecraft.spruce_stairs": "Fischdnhulzdrebbe",
  "block.minecraft.spruce_trapdoor": "Fischdnhulzfalldiere",
  "block.minecraft.spruce_wall_hanging_sign": "Fischdnhulzwandhängeschüld",
  "block.minecraft.spruce_wall_sign": "Fischdnhulzwandschüld",
  "block.minecraft.spruce_wood": "Fischdnhulz",
  "block.minecraft.sticky_piston": "Gläbrigorr Golbn",
  "block.minecraft.stone": "Schdeen",
  "block.minecraft.stone_brick_slab": "Schdeenzieschlschdufe",
  "block.minecraft.stone_brick_stairs": "Schdeenzieschldrebbe",
  "block.minecraft.stone_brick_wall": "Schdeenzieschlmauor",
  "block.minecraft.stone_bricks": "Schdeenzieschl",
  "block.minecraft.stone_button": "Schdeengnopp",
  "block.minecraft.stone_pressure_plate": "Schdeendruggbladde",
  "block.minecraft.stone_slab": "Schdeenschdufe",
  "block.minecraft.stone_stairs": "Schdeendrebbe",
  "block.minecraft.stonecutter": "Schdeensäsche",
  "block.minecraft.stripped_acacia_log": "Endrindedorr Agazienschdamm",
  "block.minecraft.stripped_acacia_wood": "Endrindedes Agazienhulz",
  "block.minecraft.stripped_bamboo_block": "Geschäldor Bambusblock",
  "block.minecraft.stripped_birch_log": "Endrindedorr Bürschnschdamm",
  "block.minecraft.stripped_birch_wood": "Endrindedes Bürschnhulz",
  "block.minecraft.stripped_cherry_log": "Endrindedor Kirschstamm",
  "block.minecraft.stripped_cherry_wood": "Endrindedes Kirschholz",
  "block.minecraft.stripped_crimson_hyphae": "Geschälde Garmesinhyphn",
  "block.minecraft.stripped_crimson_stem": "Geschäldorr Garmesinschdiel",
  "block.minecraft.stripped_dark_oak_log": "Endrindedorr Schworzeischnschdamm",
  "block.minecraft.stripped_dark_oak_wood": "Endrindedes Schworzeischnhulz",
  "block.minecraft.stripped_jungle_log": "Endrindedorr Drobnbohmschdamm",
  "block.minecraft.stripped_jungle_wood": "Endrindedes Drobnhulz",
  "block.minecraft.stripped_mangrove_log": "Endrindedorr Mangrovnschdamm",
  "block.minecraft.stripped_mangrove_wood": "Endrindedes Mangrovnhulz",
  "block.minecraft.stripped_oak_log": "Endrindedorr Eischnschdamm",
  "block.minecraft.stripped_oak_wood": "Endrindedes Eischnhulz",
  "block.minecraft.stripped_pale_oak_log": "Entrindeter Blasseichenstamm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindetes Blasseichenholz",
  "block.minecraft.stripped_spruce_log": "Endrindedorr Fischdnschdamm",
  "block.minecraft.stripped_spruce_wood": "Endrindedes Fischdnhulz",
  "block.minecraft.stripped_warped_hyphae": "Geschälde Würrhyphn",
  "block.minecraft.stripped_warped_stem": "Geschäldorr Würrschdiel",
  "block.minecraft.structure_block": "Gonsdrugtschoonsblogg",
  "block.minecraft.structure_void": "Gonsdrugtschoonsleere",
  "block.minecraft.sugar_cane": "Zuggorrrohr",
  "block.minecraft.sunflower": "Sonnenblume",
  "block.minecraft.suspicious_gravel": "Seltsamor Gies",
  "block.minecraft.suspicious_sand": "Seldsamor Sand",
  "block.minecraft.sweet_berry_bush": "Süßbeerschdrauch",
  "block.minecraft.tall_dry_grass": "Hohes Droggnes Geschdrüpp",
  "block.minecraft.tall_grass": "Hohes Gras",
  "block.minecraft.tall_seagrass": "Hohes Seegras",
  "block.minecraft.target": "Zielblogg",
  "block.minecraft.terracotta": "Geramigg",
  "block.minecraft.test_block": "Tesdblogg",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Gedöndes Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT‐Explosionen sind deaktiviert",
  "block.minecraft.torch": "Faggl",
  "block.minecraft.torchflower": "Fackllilie",
  "block.minecraft.torchflower_crop": "Fackllilienpflanze",
  "block.minecraft.trapped_chest": "Redstone-Druhe",
  "block.minecraft.trial_spawner": "Prüfungs-Spawnorr",
  "block.minecraft.tripwire": "Schdolbordrahd",
  "block.minecraft.tripwire_hook": "Hagn",
  "block.minecraft.tube_coral": "Orschlgoralle",
  "block.minecraft.tube_coral_block": "Orschlgorallnblogg",
  "block.minecraft.tube_coral_fan": "Orschlgorallnfäschorr",
  "block.minecraft.tube_coral_wall_fan": "Orschlgorallnwandfäschorr",
  "block.minecraft.tuff": "Tuffschdeen",
  "block.minecraft.tuff_brick_slab": "Tuffsteenzieschlschdufe",
  "block.minecraft.tuff_brick_stairs": "Tuffsteenzieschldrebbe",
  "block.minecraft.tuff_brick_wall": "Tuffsteenzieschlmauorr",
  "block.minecraft.tuff_bricks": "Tuffsteenzieschl",
  "block.minecraft.tuff_slab": "Tuffsteenschdufe",
  "block.minecraft.tuff_stairs": "Tuffsteendrebbe",
  "block.minecraft.tuff_wall": "Tuffsteenmauorr",
  "block.minecraft.turtle_egg": "Schüldgrödnei",
  "block.minecraft.twisting_vines": "Zwürblrangn",
  "block.minecraft.twisting_vines_plant": "Zwürblrangnpflanze",
  "block.minecraft.vault": "Dresorr",
  "block.minecraft.verdant_froglight": "Junggrienes Fruschlichd",
  "block.minecraft.vine": "Rangn",
  "block.minecraft.void_air": "Leernlufd",
  "block.minecraft.wall_torch": "Wandfaggl",
  "block.minecraft.warped_button": "Würrgnopp",
  "block.minecraft.warped_door": "Würrdiere",
  "block.minecraft.warped_fence": "Würrzaun",
  "block.minecraft.warped_fence_gate": "Würrzaundorr",
  "block.minecraft.warped_fungus": "Würrbilz",
  "block.minecraft.warped_hanging_sign": "Würrhängeschüld",
  "block.minecraft.warped_hyphae": "Würrhyphn",
  "block.minecraft.warped_nylium": "Würr-Nädsl",
  "block.minecraft.warped_planks": "Würrbreddorr",
  "block.minecraft.warped_pressure_plate": "Würrdruggbladde",
  "block.minecraft.warped_roots": "Würrwurdsln",
  "block.minecraft.warped_shelf": "Würrregal",
  "block.minecraft.warped_sign": "Würrschüld",
  "block.minecraft.warped_slab": "Würrschdufe",
  "block.minecraft.warped_stairs": "Würrdrebbe",
  "block.minecraft.warped_stem": "Würrschdiel",
  "block.minecraft.warped_trapdoor": "Würrfalldiere",
  "block.minecraft.warped_wall_hanging_sign": "Würrwandhängeschüld",
  "block.minecraft.warped_wall_sign": "Würrwandschüld",
  "block.minecraft.warped_wart_block": "Würrwarznblogg",
  "block.minecraft.water": "Wassorr",
  "block.minecraft.water_cauldron": "Wassorrgessl",
  "block.minecraft.waxed_chiseled_copper": "Gewachsdorr gemeißeldorr Gupforrblogg",
  "block.minecraft.waxed_copper_bars": "Gewachsde Gupforrgidder",
  "block.minecraft.waxed_copper_block": "Gewachsdorr Gupforrblogg",
  "block.minecraft.waxed_copper_bulb": "Gewachsde Gupforrleuchde",
  "block.minecraft.waxed_copper_chain": "Gewachsde Gupforrgedde",
  "block.minecraft.waxed_copper_chest": "Gewachsde Gupforrdruhe",
  "block.minecraft.waxed_copper_door": "Gewachsde Gupforrdiere",
  "block.minecraft.waxed_copper_golem_statue": "Gewachsdes Gupforrgolemmännl",
  "block.minecraft.waxed_copper_grate": "Gewachsdorr Gupforrrost",
  "block.minecraft.waxed_copper_lantern": "Gewachsde Gupforrleuchde",
  "block.minecraft.waxed_copper_trapdoor": "Gewachsde Gupforrfalldiere",
  "block.minecraft.waxed_cut_copper": "Gewachsdorr geschniddnorr Gupforrblogg",
  "block.minecraft.waxed_cut_copper_slab": "Gewachsde geschniddne Gupforrschdufe",
  "block.minecraft.waxed_cut_copper_stairs": "Gewachsde geschniddne Gupforrdrebbe",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gewachsdorr blangorr gemeißeldorr Gupferblogg",
  "block.minecraft.waxed_exposed_copper": "Gewachsdorr blangorr Gupforrblogg",
  "block.minecraft.waxed_exposed_copper_bars": "Gewachsde blange Gupforrgidder",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewachsde blange Gupferleuchde",
  "block.minecraft.waxed_exposed_copper_chain": "Gewachsde blange Gupforrkedde",
  "block.minecraft.waxed_exposed_copper_chest": "Gewachsde blange Gupforrdruhe",
  "block.minecraft.waxed_exposed_copper_door": "Gewachsde blange Gupferdiere",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gewachsdes blanges Gupforrgolemmännl",
  "block.minecraft.waxed_exposed_copper_grate": "Gewachsdorr blangorr Gupferrost",
  "block.minecraft.waxed_exposed_copper_lantern": "Gewachsde blange Gupforrladerne",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gewachsde blange Gupforrfalldiere",
  "block.minecraft.waxed_exposed_cut_copper": "Gewachsdorr blangorr geschniddnorr Gupforrblogg",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewachsde blange geschniddne Gupforrschdufe",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gewachsde blange geschniddne Gupforrdrebbe",
  "block.minecraft.waxed_exposed_lightning_rod": "Gewachsder blanger Blitzableider",
  "block.minecraft.waxed_lightning_rod": "Gewachsder Blitzableider",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gewachsdorr oxidierdorr gemeißeldorr Gupferblogg",
  "block.minecraft.waxed_oxidized_copper": "Gewachsdorr oxidierdorr Gupforrblogg",
  "block.minecraft.waxed_oxidized_copper_bars": "Gewachsde rostsche Gupforrgidder",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gewachsde oxidierde Gupferleude",
  "block.minecraft.waxed_oxidized_copper_chain": "Gewachsde rostsche Gupforrkedde",
  "block.minecraft.waxed_oxidized_copper_chest": "Gewachsde rostsche Gupforrdruhe",
  "block.minecraft.waxed_oxidized_copper_door": "Gewachsde oxidierde Gupferdiere",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gewachsdes rostsches Gupforrgolemmännl",
  "block.minecraft.waxed_oxidized_copper_grate": "Gewachdorr oxidierdorr Gupferrost",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gewachsde rostsche Gupforrladerne",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gewachsde oxidierde Gupforrfalldiere",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewachsdorr oxidierdorr geschniddnorr Gupforrblogg",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewachsde oxidierde geschniddne Gupforrschdufe",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gewachsde oxidierde geschniddne Gupforrdrebbe",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gewachsder rostscher Blitzableider",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gewachsdorr vorrwiddorrdorr gemeißeldorr Gupferblogg",
  "block.minecraft.waxed_weathered_copper": "Gewachsdorr vorrwiddorrdorr Gupforrblogg",
  "block.minecraft.waxed_weathered_copper_bars": "Gewachsdes vorrwiddorrdes Gupforrgidder",
  "block.minecraft.waxed_weathered_copper_bulb": "Gewachde vorrwiddorrde Gupferleuchde",
  "block.minecraft.waxed_weathered_copper_chain": "Gewachsde vorrwiddorrde Gupforrkedde",
  "block.minecraft.waxed_weathered_copper_chest": "Gewachsde vorrwiddorrde Gupforrdruhe",
  "block.minecraft.waxed_weathered_copper_door": "Gewachsde vorrwiddorrde Gupferdiere",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gewachsdes vorwiddorrdes Gupforrgolemmännl",
  "block.minecraft.waxed_weathered_copper_grate": "Gewachsdorr vorrwiddorrdorr Gupferrost",
  "block.minecraft.waxed_weathered_copper_lantern": "Gewachsde vorrwiddorrde Gupforrladerne",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gewachsde vorrwiddorrde Gupforrfalldiere",
  "block.minecraft.waxed_weathered_cut_copper": "Gewachsdorr vorrwiddorrdorr geschniddnorr Gupforrblogg",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewachsde vorrwiddorrde geschniddne Gupforrschdufe",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gewachsde vorrwiddorrde geschniddne Gupforrdrebbe",
  "block.minecraft.waxed_weathered_lightning_rod": "Gewachsder vorrwiddorrder Blitzableider",
  "block.minecraft.weathered_chiseled_copper": "Vorrwiddorrdorr gemeißeldorr Gupferblogg",
  "block.minecraft.weathered_copper": "Vorrwiddorrdorr Gupforrblogg",
  "block.minecraft.weathered_copper_bars": "Vorrwiddorrde Gupforrgidder",
  "block.minecraft.weathered_copper_bulb": "Vorrwiddorrde Gupferleuchde",
  "block.minecraft.weathered_copper_chain": "Vorrwiddorrde Gupferkedde",
  "block.minecraft.weathered_copper_chest": "Vorrwiddorrde Gupforrdruhe",
  "block.minecraft.weathered_copper_door": "Vorrwiddorrde Gupferdiere",
  "block.minecraft.weathered_copper_golem_statue": "Vorrwiddorrdes Gupforrgolemmännl",
  "block.minecraft.weathered_copper_grate": "Vorrwiddorrdorr Gupferrost",
  "block.minecraft.weathered_copper_lantern": "Vorrwiddorrde Gupforrladerne",
  "block.minecraft.weathered_copper_trapdoor": "Vorrwiddorrde Gupforrfalldiere",
  "block.minecraft.weathered_cut_copper": "Vorrwiddorrdorr geschniddnorr Gupforrblogg",
  "block.minecraft.weathered_cut_copper_slab": "Vorrwiddorrde geschniddne Gupforrschdufe",
  "block.minecraft.weathered_cut_copper_stairs": "Vorrwiddorrde geschniddne Gupforrdrebbe",
  "block.minecraft.weathered_lightning_rod": "Vorrwiddorrder Blitzableider",
  "block.minecraft.weeping_vines": "Drauorrrangn",
  "block.minecraft.weeping_vines_plant": "Drauorrrangnpflanze",
  "block.minecraft.wet_sponge": "Nassorr Schwamm",
  "block.minecraft.wheat": "Weidsnpflanze",
  "block.minecraft.white_banner": "Weeßes Bannorr",
  "block.minecraft.white_bed": "Weeßes Bädde",
  "block.minecraft.white_candle": "Weeße Gerdse",
  "block.minecraft.white_candle_cake": "Guchn mid weeßorr Gerdse",
  "block.minecraft.white_carpet": "Weeßorr Täppsch",
  "block.minecraft.white_concrete": "Weeßorr Bedong",
  "block.minecraft.white_concrete_powder": "Weeßorr Droggnbedong",
  "block.minecraft.white_glazed_terracotta": "Weeße glasierde Geramigg",
  "block.minecraft.white_shulker_box": "Weeße Shulker-Gissde",
  "block.minecraft.white_stained_glass": "Weeßes Glas",
  "block.minecraft.white_stained_glass_pane": "Weeße Glasscheebe",
  "block.minecraft.white_terracotta": "Weeße Geramigg",
  "block.minecraft.white_tulip": "Weeße Dulbe",
  "block.minecraft.white_wool": "Weeße Wolle",
  "block.minecraft.wildflowers": "Wildblümln",
  "block.minecraft.wither_rose": "Wither-Rose",
  "block.minecraft.wither_skeleton_skull": "Witherschgeleddnischl",
  "block.minecraft.wither_skeleton_wall_skull": "Witherschgeledd-Wandnischl",
  "block.minecraft.yellow_banner": "Gelbes Bannorr",
  "block.minecraft.yellow_bed": "Gelbes Bädde",
  "block.minecraft.yellow_candle": "Gelbe Gerdse",
  "block.minecraft.yellow_candle_cake": "Guchn mid gelborr Gerdse",
  "block.minecraft.yellow_carpet": "Gelborr Täppsch",
  "block.minecraft.yellow_concrete": "Gelborr Bedong",
  "block.minecraft.yellow_concrete_powder": "Gelborr Droggnbedong",
  "block.minecraft.yellow_glazed_terracotta": "Gelbe glasierde Geramigg",
  "block.minecraft.yellow_shulker_box": "Gelbe Shulker-Gissde",
  "block.minecraft.yellow_stained_glass": "Gelbes Glas",
  "block.minecraft.yellow_stained_glass_pane": "Gelbe Glasscheebe",
  "block.minecraft.yellow_terracotta": "Gelbe Geramigg",
  "block.minecraft.yellow_wool": "Gelbe Wolle",
  "block.minecraft.zombie_head": "Zombienischl",
  "block.minecraft.zombie_wall_head": "Zombie-Wandnischl",
  "item.minecraft.acacia_boat": "Agazienhulzbood",
  "item.minecraft.acacia_chest_boat": "Agazienhulzdruhnbood",
  "item.minecraft.allay_spawn_egg": "Hilfsgeisd-Schborn-Ei",
  "item.minecraft.amethyst_shard": "Amethystschärbe",
  "item.minecraft.angler_pottery_shard": "Angler-Töpferscherbe",
  "item.minecraft.angler_pottery_sherd": "Angler-Töpferscherbe",
  "item.minecraft.apple": "Abbl",
  "item.minecraft.archer_pottery_shard": "Schützen-Töpferscherbe",
  "item.minecraft.archer_pottery_sherd": "Schützen-Töpferscherbe",
  "item.minecraft.armadillo_scute": "Gürteltier-Hornschild",
  "item.minecraft.armadillo_spawn_egg": "Gürteltier-Spawn-Ei",
  "item.minecraft.armor_stand": "Rüsdungsschdändorr",
  "item.minecraft.arms_up_pottery_shard": "Gebärden-Töpferscherbe",
  "item.minecraft.arms_up_pottery_sherd": "Gebärden-Töpferscherbe",
  "item.minecraft.arrow": "Pfeil",
  "item.minecraft.axolotl_bucket": "Aggsolodlehmorr",
  "item.minecraft.axolotl_spawn_egg": "Aggsolodl-Schborn-Ei",
  "item.minecraft.baked_potato": "Ofngardoffl",
  "item.minecraft.bamboo_chest_raft": "Bambus-Truhenfloß",
  "item.minecraft.bamboo_raft": "Bambusfloß",
  "item.minecraft.bat_spawn_egg": "Flädorrmaus-Schborn-Ei",
  "item.minecraft.bee_spawn_egg": "Bien-Schborn-Ei",
  "item.minecraft.beef": "Rohes Rindfleesch",
  "item.minecraft.beetroot": "Rode Beede",
  "item.minecraft.beetroot_seeds": "Rode-Beede-Samn",
  "item.minecraft.beetroot_soup": "Borschdsch",
  "item.minecraft.birch_boat": "Bürschnhulzbood",
  "item.minecraft.birch_chest_boat": "Bürschnhulzdruhnbood",
  "item.minecraft.black_bundle": "Schwarzes Bündel",
  "item.minecraft.black_dye": "Schworzorr Farbschdoff",
  "item.minecraft.black_harness": "Schwarzes Geschirr",
  "item.minecraft.blade_pottery_shard": "Klingen-Töpferscherbe",
  "item.minecraft.blade_pottery_sherd": "Klingen-Töpferscherbe",
  "item.minecraft.blaze_powder": "Lohänschdaub",
  "item.minecraft.blaze_rod": "Lohänrude",
  "item.minecraft.blaze_spawn_egg": "Lohän-Schborn-Ei",
  "item.minecraft.blue_bundle": "Blaues Bündel",
  "item.minecraft.blue_dye": "Blauorr Farbschdoff",
  "item.minecraft.blue_egg": "Blaues Ei",
  "item.minecraft.blue_harness": "Blaues Geschirr",
  "item.minecraft.bogged_spawn_egg": "Sumpfskelett-Spawn-Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolzen-Rüstungsbesatz",
  "item.minecraft.bone": "Gnochn",
  "item.minecraft.bone_meal": "Gnochnmehl",
  "item.minecraft.book": "Schwahrde",
  "item.minecraft.bordure_indented_banner_pattern": "Spickelbord-Bannervorlage",
  "item.minecraft.bow": "Bouchn",
  "item.minecraft.bowl": "Schüssl",
  "item.minecraft.bread": "Broud",
  "item.minecraft.breeze_rod": "Böenrute",
  "item.minecraft.breeze_spawn_egg": "Böen-Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töpferscherbe",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töpferscherbe",
  "item.minecraft.brewing_stand": "Brauschdand",
  "item.minecraft.brick": "Zieschl",
  "item.minecraft.brown_bundle": "Braunes Bündel",
  "item.minecraft.brown_dye": "Braunorr Farbschdoff",
  "item.minecraft.brown_egg": "Braunes Ei",
  "item.minecraft.brown_harness": "Braunes Geschirr",
  "item.minecraft.brush": "Pinsel",
  "item.minecraft.bucket": "Ehmorr",
  "item.minecraft.bundle": "Bündl",
  "item.minecraft.bundle.empty": "Leer",
  "item.minecraft.bundle.empty.description": "Nimmt einen gemischten Stapel Gegenstände auf",
  "item.minecraft.bundle.full": "Voll",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flammen-Töpferscherbe",
  "item.minecraft.burn_pottery_sherd": "Flammen-Töpferscherbe",
  "item.minecraft.camel_husk_spawn_egg": "Zombiedromedar-Spawn-Ei",
  "item.minecraft.camel_spawn_egg": "Dromedar-Spawn-Ei",
  "item.minecraft.carrot": "Möhre",
  "item.minecraft.carrot_on_a_stick": "Möhrnrude",
  "item.minecraft.cat_spawn_egg": "Miedsekaddsn-Schborn-Ei",
  "item.minecraft.cauldron": "Gessl",
  "item.minecraft.cave_spider_spawn_egg": "Höhlnschbinn-Schborn-Ei",
  "item.minecraft.chainmail_boots": "Keddnlaadschn",
  "item.minecraft.chainmail_chestplate": "Keddnhemd",
  "item.minecraft.chainmail_helmet": "Keddnhaube",
  "item.minecraft.chainmail_leggings": "Keddnhose",
  "item.minecraft.charcoal": "Hulzgohle",
  "item.minecraft.cherry_boat": "Kirschholzboot",
  "item.minecraft.cherry_chest_boat": "Kirschholztruhenboot",
  "item.minecraft.chest_minecart": "Güdorrlore",
  "item.minecraft.chicken": "Rohes Hühnschn",
  "item.minecraft.chicken_spawn_egg": "Hühnschn-Schborn-Ei",
  "item.minecraft.chorus_fruit": "Chorusfruchd",
  "item.minecraft.clay_ball": "Donglumbn",
  "item.minecraft.clock": "Uhr",
  "item.minecraft.coal": "Gohle",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Küsten-Rüstungsbesatz",
  "item.minecraft.cocoa_beans": "Gaggaubohn",
  "item.minecraft.cod": "Rohorr Gabljau",
  "item.minecraft.cod_bucket": "Gabljauehmorr",
  "item.minecraft.cod_spawn_egg": "Gabljau-Schborn-Ei",
  "item.minecraft.command_block_minecart": "Befählsblogglore",
  "item.minecraft.compass": "Gombass",
  "item.minecraft.cooked_beef": "Schdeak",
  "item.minecraft.cooked_chicken": "Gebradnes Hühnschn",
  "item.minecraft.cooked_cod": "Gebradnorr Gabljau",
  "item.minecraft.cooked_mutton": "Gebradnes Hammlfleesch",
  "item.minecraft.cooked_porkchop": "Gebradnes Schweenefleesch",
  "item.minecraft.cooked_rabbit": "Gebradnes Garniggl",
  "item.minecraft.cooked_salmon": "Gebradnorr Lachs",
  "item.minecraft.cookie": "Gehgs",
  "item.minecraft.copper_axe": "Kupferaxt",
  "item.minecraft.copper_boots": "Kupferstiefel",
  "item.minecraft.copper_chestplate": "Kupferharnisch",
  "item.minecraft.copper_golem_spawn_egg": "Kupfergolem-Spawn-Ei",
  "item.minecraft.copper_helmet": "Kupferhelm",
  "item.minecraft.copper_hoe": "Kupferhacke",
  "item.minecraft.copper_horse_armor": "Kupferner Rossharnisch",
  "item.minecraft.copper_ingot": "Gupforrbarrn",
  "item.minecraft.copper_leggings": "Kupferbeinschutz",
  "item.minecraft.copper_nautilus_armor": "Kupferner Nautiluspanzer",
  "item.minecraft.copper_nugget": "Kupferklumpen",
  "item.minecraft.copper_pickaxe": "Kupferspitzhacke",
  "item.minecraft.copper_shovel": "Kupferschaufel",
  "item.minecraft.copper_spear": "Kupferspeer",
  "item.minecraft.copper_sword": "Kupferschwert",
  "item.minecraft.cow_spawn_egg": "Guh-Schborn-Ei",
  "item.minecraft.creaking_spawn_egg": "Knarz-Spawn-Ei",
  "item.minecraft.creeper_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervorlage",
  "item.minecraft.creeper_spawn_egg": "Creeper-Schborn-Ei",
  "item.minecraft.crossbow": "Armbrusd",
  "item.minecraft.crossbow.projectile": "Geschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Geschoss: %s× %s",
  "item.minecraft.crossbow.projectile.single": "Geschoss: %s",
  "item.minecraft.cyan_bundle": "Türkises Bündel",
  "item.minecraft.cyan_dye": "Dürgisorr Farbschdoff",
  "item.minecraft.cyan_harness": "Türkises Geschirr",
  "item.minecraft.danger_pottery_shard": "Gefahren-Töpferscherbe",
  "item.minecraft.danger_pottery_sherd": "Gefahren-Töpferscherbe",
  "item.minecraft.dark_oak_boat": "Schworzeischnhulzbood",
  "item.minecraft.dark_oak_chest_boat": "Schworzeischnhulzdruhnbood",
  "item.minecraft.debug_stick": "Debug-Schdogg",
  "item.minecraft.debug_stick.empty": "%s had keene Bloggzuschdände",
  "item.minecraft.debug_stick.select": "‚%s‘ ausgewähld (%s)",
  "item.minecraft.debug_stick.update": "‚%s‘ is jäddse %s",
  "item.minecraft.diamond": "Diamand",
  "item.minecraft.diamond_axe": "Diamandaggsd",
  "item.minecraft.diamond_boots": "Diamandlaadschn",
  "item.minecraft.diamond_chestplate": "Diamandharnüsch",
  "item.minecraft.diamond_helmet": "Diamandhälm",
  "item.minecraft.diamond_hoe": "Diamandhagge",
  "item.minecraft.diamond_horse_armor": "Diamandnorr Rossharnüsch",
  "item.minecraft.diamond_leggings": "Diamandbeenschudds",
  "item.minecraft.diamond_nautilus_armor": "Diamantener Nautiluspanzer",
  "item.minecraft.diamond_pickaxe": "Diamandschbiddshagge",
  "item.minecraft.diamond_shovel": "Diamandschibbe",
  "item.minecraft.diamond_spear": "Diamantspeer",
  "item.minecraft.diamond_sword": "Diamandschwerd",
  "item.minecraft.disc_fragment_5": "Bladdnbruchschdügg",
  "item.minecraft.disc_fragment_5.desc": "Schallbladde - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Schborn-Ei",
  "item.minecraft.donkey_spawn_egg": "Esl-Schborn-Ei",
  "item.minecraft.dragon_breath": "Drachnadem",
  "item.minecraft.dried_kelp": "Gedroggnedorr Seedang",
  "item.minecraft.drowned_spawn_egg": "Erdrungnen-Schborn-Ei",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungsbesatz",
  "item.minecraft.echo_shard": "Echoscherbe",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Großorr-Wäschdorr-Schborn-Ei",
  "item.minecraft.elytra": "Elydren",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Vorzauborde Schwahrde",
  "item.minecraft.enchanted_golden_apple": "Vorzaubordorr goldnorr Abbl",
  "item.minecraft.end_crystal": "Endergrisdall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrachn-Schborn-Ei",
  "item.minecraft.ender_eye": "Enderooche",
  "item.minecraft.ender_pearl": "Enderbärle",
  "item.minecraft.enderman_spawn_egg": "Enderman-Schborn-Ei",
  "item.minecraft.endermite_spawn_egg": "Endermiten-Schborn-Ei",
  "item.minecraft.evoker_spawn_egg": "Magiorr-Schborn-Ei",
  "item.minecraft.experience_bottle": "Erfahrungsfläschschn",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Töpferscherbe",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Töpferscherbe",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Augen-Rüstungsbesatz",
  "item.minecraft.feather": "Fädorr",
  "item.minecraft.fermented_spider_eye": "Fermendierdes Schbinnooche",
  "item.minecraft.field_masoned_banner_pattern": "Mauerung-Bannervorlage",
  "item.minecraft.filled_map": "Garde",
  "item.minecraft.fire_charge": "Feuorrguchl",
  "item.minecraft.firework_rocket": "Feuorrwergsragede",
  "item.minecraft.firework_rocket.flight": "Flugdauorr:",
  "item.minecraft.firework_rocket.multiple_stars": "%s× %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feuorrwergsschdern",
  "item.minecraft.firework_star.black": "Schworz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Braun",
  "item.minecraft.firework_star.custom_color": "Angebassd",
  "item.minecraft.firework_star.cyan": "Dürgis",
  "item.minecraft.firework_star.fade_to": "Üborrgang zu",
  "item.minecraft.firework_star.flicker": "Fungln",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grien",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Hellgrau",
  "item.minecraft.firework_star.lime": "Hellgrien",
  "item.minecraft.firework_star.magenta": "Magenda",
  "item.minecraft.firework_star.orange": "Orangsch",
  "item.minecraft.firework_star.pink": "Ping",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Rod",
  "item.minecraft.firework_star.shape": "Unbegannde Form",
  "item.minecraft.firework_star.shape.burst": "Eggsblosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperförmisch",
  "item.minecraft.firework_star.shape.large_ball": "Große Guchl",
  "item.minecraft.firework_star.shape.small_ball": "Gleene Guchl",
  "item.minecraft.firework_star.shape.star": "Schdernförmisch",
  "item.minecraft.firework_star.trail": "Schweif",
  "item.minecraft.firework_star.white": "Weeß",
  "item.minecraft.firework_star.yellow": "Gelb",
  "item.minecraft.fishing_rod": "Angl",
  "item.minecraft.flint": "Feuorrschdeen",
  "item.minecraft.flint_and_steel": "Feuorrzeusch",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstungsbesatz",
  "item.minecraft.flow_banner_pattern": "Bannervorlage",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervorlage",
  "item.minecraft.flow_pottery_sherd": "Fluss-Töpferscherbe",
  "item.minecraft.flower_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.flower_banner_pattern.desc": "Blume",
  "item.minecraft.flower_banner_pattern.new": "Blumen-Bannervorlage",
  "item.minecraft.flower_pot": "Bluhmdobb",
  "item.minecraft.fox_spawn_egg": "Fuggs-Schborn-Ei",
  "item.minecraft.friend_pottery_shard": "Freundes-Töpferscherbe",
  "item.minecraft.friend_pottery_sherd": "Freundes-Töpferscherbe",
  "item.minecraft.frog_spawn_egg": "Frusch-Schborn-Ei",
  "item.minecraft.furnace_minecart": "Ofnlore",
  "item.minecraft.ghast_spawn_egg": "Ghast-Schborn-Ei",
  "item.minecraft.ghast_tear": "Ghastdrähne",
  "item.minecraft.glass_bottle": "Glasbulle",
  "item.minecraft.glistering_melon_slice": "Glidzornde Melonscheibe",
  "item.minecraft.globe_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervorlage",
  "item.minecraft.glow_berries": "Leuschdbeern",
  "item.minecraft.glow_ink_sac": "Leuschddindnbeudl",
  "item.minecraft.glow_item_frame": "Leuschdrahm",
  "item.minecraft.glow_squid_spawn_egg": "Leuschddindnfisch-Schborn-Ei",
  "item.minecraft.glowstone_dust": "Leuschdschdeenschdaub",
  "item.minecraft.goat_horn": "Boggshorn",
  "item.minecraft.goat_spawn_egg": "Zieschn-Schborn-Ei",
  "item.minecraft.gold_ingot": "Goldbarrn",
  "item.minecraft.gold_nugget": "Goldglumbn",
  "item.minecraft.golden_apple": "Goldnorr Abbl",
  "item.minecraft.golden_axe": "Goldaggsd",
  "item.minecraft.golden_boots": "Goldlaadschn",
  "item.minecraft.golden_carrot": "Guldne Möhre",
  "item.minecraft.golden_chestplate": "Goldharnüsch",
  "item.minecraft.golden_helmet": "Goldhälm",
  "item.minecraft.golden_hoe": "Goldhagge",
  "item.minecraft.golden_horse_armor": "Goldnorr Rossharnüsch",
  "item.minecraft.golden_leggings": "Goldbeenschudds",
  "item.minecraft.golden_nautilus_armor": "Goldener Nautiluspanzer",
  "item.minecraft.golden_pickaxe": "Goldschbiddshagge",
  "item.minecraft.golden_shovel": "Goldschibbe",
  "item.minecraft.golden_spear": "Goldspeer",
  "item.minecraft.golden_sword": "Goldschwerd",
  "item.minecraft.gray_bundle": "Graues Bündel",
  "item.minecraft.gray_dye": "Grauorr Farbschdoff",
  "item.minecraft.gray_harness": "Graues Geschirr",
  "item.minecraft.green_bundle": "Grünes Bündel",
  "item.minecraft.green_dye": "Grienorr Farbschdoff",
  "item.minecraft.green_harness": "Grünes Geschirr",
  "item.minecraft.guardian_spawn_egg": "Wäschdorr-Schborn-Ei",
  "item.minecraft.gunpowder": "Schworzbulvorr",
  "item.minecraft.guster_banner_pattern": "Bannervorlage",
  "item.minecraft.guster_banner_pattern.desc": "Windstoßer",
  "item.minecraft.guster_banner_pattern.new": "Windstoßer-Bannervorlage",
  "item.minecraft.guster_pottery_sherd": "Windstoßer-Töpferscherbe",
  "item.minecraft.happy_ghast_spawn_egg": "Glücklicher-Ghast-Spawn-Ei",
  "item.minecraft.harness": "Geschirr",
  "item.minecraft.heart_of_the_sea": "Härds des Meeres",
  "item.minecraft.heart_pottery_shard": "Herz-Töpferscherbe",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_shard": "Herzschmerz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_sherd": "Herzschmerz-Töpferscherbe",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Schborn-Ei",
  "item.minecraft.honey_bottle": "Honischbulle",
  "item.minecraft.honeycomb": "Honischwabe",
  "item.minecraft.hopper_minecart": "Drischdorrlore",
  "item.minecraft.horse_spawn_egg": "Färde-Schborn-Ei",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gastwirts-Rüstungsbesatz",
  "item.minecraft.howl_pottery_shard": "Geheul-Töpferscherbe",
  "item.minecraft.howl_pottery_sherd": "Geheul-Töpferscherbe",
  "item.minecraft.husk_spawn_egg": "Wüsdnzombie-Schborn-Ei",
  "item.minecraft.ink_sac": "Dindnbeudl",
  "item.minecraft.iron_axe": "Eisnaggsd",
  "item.minecraft.iron_boots": "Eisnlaadschn",
  "item.minecraft.iron_chestplate": "Eisnharnüsch",
  "item.minecraft.iron_golem_spawn_egg": "Eisengolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Eisnhälm",
  "item.minecraft.iron_hoe": "Eisnhagge",
  "item.minecraft.iron_horse_armor": "Eisornorr Rossharnüsch",
  "item.minecraft.iron_ingot": "Eisnbarrn",
  "item.minecraft.iron_leggings": "Eisnbeenschudds",
  "item.minecraft.iron_nautilus_armor": "Eiserner Nautiluspanzer",
  "item.minecraft.iron_nugget": "Eisnglumbn",
  "item.minecraft.iron_pickaxe": "Eisnschbiddshagge",
  "item.minecraft.iron_shovel": "Eisnschibbe",
  "item.minecraft.iron_spear": "Eisenspeer",
  "item.minecraft.iron_sword": "Eisnschwerd",
  "item.minecraft.item_frame": "Rahm",
  "item.minecraft.jungle_boat": "Drobnhulzbood",
  "item.minecraft.jungle_chest_boat": "Drobnhulzdruhnbood",
  "item.minecraft.knowledge_book": "Schwahrde des Wissens",
  "item.minecraft.lapis_lazuli": "Labisladsuli",
  "item.minecraft.lava_bucket": "Lavaehmorr",
  "item.minecraft.lead": "Leene",
  "item.minecraft.leather": "Lädor",
  "item.minecraft.leather_boots": "Lädorlaadschn",
  "item.minecraft.leather_chestplate": "Lädorjagge",
  "item.minecraft.leather_helmet": "Lädormiddse",
  "item.minecraft.leather_horse_armor": "Lädornorr Rossharnüsch",
  "item.minecraft.leather_leggings": "Lädorhose",
  "item.minecraft.light_blue_bundle": "Hellblaues Bündel",
  "item.minecraft.light_blue_dye": "Hellblauorr Farbschdoff",
  "item.minecraft.light_blue_harness": "Hellblaues Geschirr",
  "item.minecraft.light_gray_bundle": "Hellgraues Bündel",
  "item.minecraft.light_gray_dye": "Hellgrauorr Farbschdoff",
  "item.minecraft.light_gray_harness": "Hellgraues Geschirr",
  "item.minecraft.lime_bundle": "Hellgrünes Bündel",
  "item.minecraft.lime_dye": "Hellgrienorr Farbschdoff",
  "item.minecraft.lime_harness": "Hellgrünes Geschirr",
  "item.minecraft.lingering_potion": "Vorweildrang",
  "item.minecraft.lingering_potion.effect.awkward": "Seldsamorr Vorweildrang",
  "item.minecraft.lingering_potion.effect.empty": "Nisch braubarorr Vorweildrang",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Vorweildrang dorr Feuorrresisdenz",
  "item.minecraft.lingering_potion.effect.harming": "Vorweildrang des Schadns",
  "item.minecraft.lingering_potion.effect.healing": "Vorweildrang dorr Heilung",
  "item.minecraft.lingering_potion.effect.infested": "Verweiltrank des Befalls",
  "item.minecraft.lingering_potion.effect.invisibility": "Vorweildrang dorr Unsischdbarkeed",
  "item.minecraft.lingering_potion.effect.leaping": "Vorweildrang dorr Schbrunggrafd",
  "item.minecraft.lingering_potion.effect.levitation": "Vorweildrang dorr Schwebegrafd",
  "item.minecraft.lingering_potion.effect.luck": "Vorweildrang des Glüggs",
  "item.minecraft.lingering_potion.effect.mundane": "Gewöhnlischorr Vorweildrang",
  "item.minecraft.lingering_potion.effect.night_vision": "Vorweildrang dorr Nachdsischd",
  "item.minecraft.lingering_potion.effect.oozing": "Verweiltrank des Schleimens",
  "item.minecraft.lingering_potion.effect.poison": "Vorweildrang dorr Vorgifdung",
  "item.minecraft.lingering_potion.effect.regeneration": "Vorweildrang dorr Regenoration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Vorweildrang des sanfdn Falls",
  "item.minecraft.lingering_potion.effect.slowness": "Vorweildrang dorr Langsamkeed",
  "item.minecraft.lingering_potion.effect.strength": "Vorweildrang dorr Schdärge",
  "item.minecraft.lingering_potion.effect.swiftness": "Vorweildrang dorr Schnellischkeed",
  "item.minecraft.lingering_potion.effect.thick": "Diggflüss’schorr Vorweildrang",
  "item.minecraft.lingering_potion.effect.turtle_master": "Vorweildrang des Schüldgrödnmeisdors",
  "item.minecraft.lingering_potion.effect.water": "Vorweilnde Wassorrbulle",
  "item.minecraft.lingering_potion.effect.water_breathing": "Vorweildrang dorr Undorrwassorradmung",
  "item.minecraft.lingering_potion.effect.weakness": "Vorweildrang dorr Schwäsche",
  "item.minecraft.lingering_potion.effect.weaving": "Verweiltrank des Webens",
  "item.minecraft.lingering_potion.effect.wind_charged": "Verweiltrank der Windladung",
  "item.minecraft.llama_spawn_egg": "Lama-Schborn-Ei",
  "item.minecraft.lodestone_compass": "Leidschdeen-Gombass",
  "item.minecraft.mace": "Streitkolben",
  "item.minecraft.magenta_bundle": "Magenta Bündel",
  "item.minecraft.magenta_dye": "Magenda Farbschdoff",
  "item.minecraft.magenta_harness": "Magenta Geschirr",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmawürfl-Schborn-Ei",
  "item.minecraft.mangrove_boat": "Mangrovnhulzbood",
  "item.minecraft.mangrove_chest_boat": "Mangrovnhulzdruhnbood",
  "item.minecraft.map": "Leere Garde",
  "item.minecraft.melon_seeds": "Melongerne",
  "item.minecraft.melon_slice": "Melonscheibe",
  "item.minecraft.milk_bucket": "Milschehmorr",
  "item.minecraft.minecart": "Lore",
  "item.minecraft.miner_pottery_shard": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.miner_pottery_sherd": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.mojang_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Mojang-Logo-Bannervorlage",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Schborn-Ei",
  "item.minecraft.mourner_pottery_shard": "Wimmerer-Töpferscherbe",
  "item.minecraft.mourner_pottery_sherd": "Wimmerer-Töpferscherbe",
  "item.minecraft.mule_spawn_egg": "Mauldier-Schborn-Ei",
  "item.minecraft.mushroom_stew": "Bilzsubbe",
  "item.minecraft.music_disc_11": "Schallbladde",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schallbladde",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schallbladde",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schallbladde",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schallbladde",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schallbladde",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schallplatte",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schallplatte",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Spieluhr)",
  "item.minecraft.music_disc_far": "Schallbladde",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplatte",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schallbladde",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schallbladde",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schallbladde",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schallbladde",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schallplatte",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schallbladde",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schallbladde",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schallbladde",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schallplatte",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schallbladde",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schallbladde",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rohes Hammlfleesch",
  "item.minecraft.name_tag": "Namsschüld",
  "item.minecraft.nautilus_shell": "Naudilusschale",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ei",
  "item.minecraft.nether_brick": "Netherzieschl",
  "item.minecraft.nether_star": "Netherschdern",
  "item.minecraft.nether_wart": "Netherwarze",
  "item.minecraft.netherite_axe": "Nädderidaggsd",
  "item.minecraft.netherite_boots": "Nädderidlaadschn",
  "item.minecraft.netherite_chestplate": "Nädderidharnüsch",
  "item.minecraft.netherite_helmet": "Nädderidhälm",
  "item.minecraft.netherite_hoe": "Nädderidhagge",
  "item.minecraft.netherite_horse_armor": "Netheritener Rossharnisch",
  "item.minecraft.netherite_ingot": "Nädderidbarrn",
  "item.minecraft.netherite_leggings": "Nädderidbeenschudds",
  "item.minecraft.netherite_nautilus_armor": "Netheritener Nautiluspanzer",
  "item.minecraft.netherite_pickaxe": "Nädderidschbiddshagge",
  "item.minecraft.netherite_scrap": "Nädderidschdügge",
  "item.minecraft.netherite_shovel": "Nädderidschaufl",
  "item.minecraft.netherite_spear": "Netheritspeer",
  "item.minecraft.netherite_sword": "Nädderidschwerd",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedevorlage",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritaufwertung",
  "item.minecraft.oak_boat": "Eischnhulzbood",
  "item.minecraft.oak_chest_boat": "Eischnhulzdruhnbood",
  "item.minecraft.ocelot_spawn_egg": "Oddselod-Schborn-Ei",
  "item.minecraft.ominous_bottle": "Unheilvolle Flasche",
  "item.minecraft.ominous_trial_key": "Unheilvoller Prüfungsschlüssel",
  "item.minecraft.orange_bundle": "Oranges Bündel",
  "item.minecraft.orange_dye": "Orangschorr Farbschdoff",
  "item.minecraft.orange_harness": "Oranges Geschirr",
  "item.minecraft.painting": "Gemäldä",
  "item.minecraft.pale_oak_boat": "Blasseichenholzboot",
  "item.minecraft.pale_oak_chest_boat": "Blasseichenholztruhenboot",
  "item.minecraft.panda_spawn_egg": "Panda-Schborn-Ei",
  "item.minecraft.paper": "Babbiorr",
  "item.minecraft.parched_spawn_egg": "Vertrockneten-Spawn-Ei",
  "item.minecraft.parrot_spawn_egg": "Babagein-Schborn-Ei",
  "item.minecraft.phantom_membrane": "Phandomhaud",
  "item.minecraft.phantom_spawn_egg": "Phandom-Schborn-Ei",
  "item.minecraft.pig_spawn_egg": "Schweene-Schborn-Ei",
  "item.minecraft.piglin_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.piglin_banner_pattern.desc": "Gusche",
  "item.minecraft.piglin_banner_pattern.new": "Schnauzen-Bannervorlage",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbarn-Schborn-Ei",
  "item.minecraft.piglin_spawn_egg": "Piglin-Schborn-Ei",
  "item.minecraft.pillager_spawn_egg": "Plündororr-Schborn-Ei",
  "item.minecraft.pink_bundle": "Rosa Bündel",
  "item.minecraft.pink_dye": "Pingorr Farbschdoff",
  "item.minecraft.pink_harness": "Rosa Geschirr",
  "item.minecraft.pitcher_plant": "Kannenpflanze",
  "item.minecraft.pitcher_pod": "Kannenpflanzenkapsel",
  "item.minecraft.plenty_pottery_shard": "Reichtums-Töpferscherbe",
  "item.minecraft.plenty_pottery_sherd": "Reichtums-Töpferscherbe",
  "item.minecraft.poisonous_potato": "Gifdsche Gardoffl",
  "item.minecraft.polar_bear_spawn_egg": "Eisbärn-Schborn-Ei",
  "item.minecraft.popped_chorus_fruit": "Gebladdsde Chorusfruchd",
  "item.minecraft.porkchop": "Rohes Schweenefleesch",
  "item.minecraft.potato": "Gardoffl",
  "item.minecraft.potion": "Drang",
  "item.minecraft.potion.effect.awkward": "Seldsamorr Drang",
  "item.minecraft.potion.effect.empty": "Nisch braubarorr Drang",
  "item.minecraft.potion.effect.fire_resistance": "Drang dorr Feuorrresisdenz",
  "item.minecraft.potion.effect.harming": "Drang des Schadns",
  "item.minecraft.potion.effect.healing": "Drang dorr Heilung",
  "item.minecraft.potion.effect.infested": "Trank des Befalls",
  "item.minecraft.potion.effect.invisibility": "Drang dorr Unsischdbarkeed",
  "item.minecraft.potion.effect.leaping": "Drang dorr Schbrunggrafd",
  "item.minecraft.potion.effect.levitation": "Drang dorr Schwebegrafd",
  "item.minecraft.potion.effect.luck": "Drang des Glüggs",
  "item.minecraft.potion.effect.mundane": "Gewöhnlischorr Drang",
  "item.minecraft.potion.effect.night_vision": "Drang dorr Nachdsischd",
  "item.minecraft.potion.effect.oozing": "Trank des Schleimens",
  "item.minecraft.potion.effect.poison": "Drang dorr Vorgifdung",
  "item.minecraft.potion.effect.regeneration": "Drang dorr Regenoration",
  "item.minecraft.potion.effect.slow_falling": "Drang des sanfdn Falls",
  "item.minecraft.potion.effect.slowness": "Drang dorr Langsamkeed",
  "item.minecraft.potion.effect.strength": "Drang dorr Schdärge",
  "item.minecraft.potion.effect.swiftness": "Drang dorr Schnellischkeed",
  "item.minecraft.potion.effect.thick": "Diggflüss’schorr Drang",
  "item.minecraft.potion.effect.turtle_master": "Drang des Schüldgrödnmeisdors",
  "item.minecraft.potion.effect.water": "Wassorrbulle",
  "item.minecraft.potion.effect.water_breathing": "Drang dorr Undorrwassorradmung",
  "item.minecraft.potion.effect.weakness": "Drang dorr Schwäsche",
  "item.minecraft.potion.effect.weaving": "Trank des Webens",
  "item.minecraft.potion.effect.wind_charged": "Trank der Windladung",
  "item.minecraft.pottery_shard_archer": "Schützen-Töpferscherbe",
  "item.minecraft.pottery_shard_arms_up": "Gebärden-Töpferscherbe",
  "item.minecraft.pottery_shard_prize": "Juwelen-Töpferscherbe",
  "item.minecraft.pottery_shard_skull": "Totenkopf-Töpferscherbe",
  "item.minecraft.powder_snow_bucket": "Bulvorrschneeehmorr",
  "item.minecraft.prismarine_crystals": "Brismaringrisdalle",
  "item.minecraft.prismarine_shard": "Brismarinschärbe",
  "item.minecraft.prize_pottery_shard": "Juwelen-Töpferscherbe",
  "item.minecraft.prize_pottery_sherd": "Juwelen-Töpferscherbe",
  "item.minecraft.pufferfish": "Guchlfisch",
  "item.minecraft.pufferfish_bucket": "Guchlfischehmorr",
  "item.minecraft.pufferfish_spawn_egg": "Guchlfisch-Schborn-Ei",
  "item.minecraft.pumpkin_pie": "Gürbisguchn",
  "item.minecraft.pumpkin_seeds": "Gürbisgerne",
  "item.minecraft.purple_bundle": "Violettes Bündel",
  "item.minecraft.purple_dye": "Lila Farbschdoff",
  "item.minecraft.purple_harness": "Violettes Geschirr",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Rohes Garniggl",
  "item.minecraft.rabbit_foot": "Hasnpfode",
  "item.minecraft.rabbit_hide": "Garnigglfell",
  "item.minecraft.rabbit_spawn_egg": "Garniggl-Schborn-Ei",
  "item.minecraft.rabbit_stew": "Garnigglragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Aufzieher-Rüstungsbesatz",
  "item.minecraft.ravager_spawn_egg": "Vorwüsdorr-Schborn-Ei",
  "item.minecraft.raw_copper": "Rohgupforr",
  "item.minecraft.raw_gold": "Rohgold",
  "item.minecraft.raw_iron": "Roheisn",
  "item.minecraft.recovery_compass": "Bergungsgombass",
  "item.minecraft.red_bundle": "Rotes Bündel",
  "item.minecraft.red_dye": "Rodorr Farbschdoff",
  "item.minecraft.red_harness": "Rotes Geschirr",
  "item.minecraft.redstone": "Redstone-Schdoob",
  "item.minecraft.resin_brick": "Harzziegel",
  "item.minecraft.resin_clump": "Harzklumpen",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippen-Rüstungsbesatz",
  "item.minecraft.rotten_flesh": "Vorrgammeldes Fleesch",
  "item.minecraft.saddle": "Saddl",
  "item.minecraft.salmon": "Rohorr Lachs",
  "item.minecraft.salmon_bucket": "Lachsehmorr",
  "item.minecraft.salmon_spawn_egg": "Lachs-Schborn-Ei",
  "item.minecraft.scrape_pottery_sherd": "Abschabe-Töpferscherbe",
  "item.minecraft.scute": "Hornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wachen-Rüstungsbesatz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Gestalter-Rüstungsbesatz",
  "item.minecraft.sheaf_pottery_shard": "Garben-Töpferscherbe",
  "item.minecraft.sheaf_pottery_sherd": "Garben-Töpferscherbe",
  "item.minecraft.shears": "Schähre",
  "item.minecraft.sheep_spawn_egg": "Schafs-Schborn-Ei",
  "item.minecraft.shelter_pottery_shard": "Zufluchts-Töpferscherbe",
  "item.minecraft.shelter_pottery_sherd": "Zufluchts-Töpferscherbe",
  "item.minecraft.shield": "Schüld",
  "item.minecraft.shield.black": "Schworzorr Schüld",
  "item.minecraft.shield.blue": "Blauorr Schüld",
  "item.minecraft.shield.brown": "Braunorr Schüld",
  "item.minecraft.shield.cyan": "Dürgisorr Schüld",
  "item.minecraft.shield.gray": "Grauorr Schüld",
  "item.minecraft.shield.green": "Grienorr Schüld",
  "item.minecraft.shield.light_blue": "Hellblauorr Schüld",
  "item.minecraft.shield.light_gray": "Hellgrauorr Schüld",
  "item.minecraft.shield.lime": "Hellgrienorr Schüld",
  "item.minecraft.shield.magenta": "Magenda Schüld",
  "item.minecraft.shield.orange": "Orangschorr Schüld",
  "item.minecraft.shield.pink": "Pingorr Schüld",
  "item.minecraft.shield.purple": "Lila Schüld",
  "item.minecraft.shield.red": "Rodorr Schüld",
  "item.minecraft.shield.white": "Weeßorr Schüld",
  "item.minecraft.shield.yellow": "Gelborr Schüld",
  "item.minecraft.shulker_shell": "Shulker-Schale",
  "item.minecraft.shulker_spawn_egg": "Shulker-Schborn-Ei",
  "item.minecraft.sign": "Schüld",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stille-Rüstungsbesatz",
  "item.minecraft.silverfish_spawn_egg": "Silborfischschn-Schborn-Ei",
  "item.minecraft.skeleton_horse_spawn_egg": "Schgeleddfärd-Schborn-Ei",
  "item.minecraft.skeleton_spawn_egg": "Schgeledd-Schborn-Ei",
  "item.minecraft.skull_banner_pattern": "Bannorrvorlaache",
  "item.minecraft.skull_banner_pattern.desc": "Nischl",
  "item.minecraft.skull_banner_pattern.new": "Schädel-Bannervorlage",
  "item.minecraft.skull_pottery_shard": "Totenkopf-Töpferscherbe",
  "item.minecraft.skull_pottery_sherd": "Totenkopf-Töpferscherbe",
  "item.minecraft.slime_ball": "Schleimball",
  "item.minecraft.slime_spawn_egg": "Schleim-Schborn-Ei",
  "item.minecraft.smithing_template": "Schmiedevorlage",
  "item.minecraft.smithing_template.applies_to": "Anwendbar auf:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Barren oder Kristall hinzufügen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsteil hinzufügen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barren & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Werkstoffe:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritbarren hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamandausrüsdung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstungsteil, Werkzeug oder Schwert aus Diamant hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nädderidbarrn",
  "item.minecraft.smithing_template.upgrade": "Aufwertung: ",
  "item.minecraft.sniffer_spawn_egg": "Schnüffler-Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Schnaub-Töpferscherbe",
  "item.minecraft.snort_pottery_sherd": "Schnaub-Töpferscherbe",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauzen-Rüstungsbesatz",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem-Schborn-Ei",
  "item.minecraft.snowball": "Schneeball",
  "item.minecraft.spectral_arrow": "Schbegdralpfeil",
  "item.minecraft.spider_eye": "Schbinnooche",
  "item.minecraft.spider_spawn_egg": "Schbinn-Schborn-Ei",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitzen-Rüstungsbesatz",
  "item.minecraft.splash_potion": "Wurfdrang",
  "item.minecraft.splash_potion.effect.awkward": "Seldsamorr Wurfdrang",
  "item.minecraft.splash_potion.effect.empty": "Nisch braubarorr Wurfdrang",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wurfdrang dorr Feuorrresisdenz",
  "item.minecraft.splash_potion.effect.harming": "Wurfdrang des Schadns",
  "item.minecraft.splash_potion.effect.healing": "Wurfdrang dorr Heilung",
  "item.minecraft.splash_potion.effect.infested": "Wurftrank des Befalls",
  "item.minecraft.splash_potion.effect.invisibility": "Wurfdrang dorr Unsischdbarkeed",
  "item.minecraft.splash_potion.effect.leaping": "Wurfdrang dorr Schbrunggrafd",
  "item.minecraft.splash_potion.effect.levitation": "Wurfdrang dorr Schwebegrafd",
  "item.minecraft.splash_potion.effect.luck": "Wurfdrang des Glüggs",
  "item.minecraft.splash_potion.effect.mundane": "Gewöhnlischorr Wurfdrang",
  "item.minecraft.splash_potion.effect.night_vision": "Wurfdrang dorr Nachdsischd",
  "item.minecraft.splash_potion.effect.oozing": "Wurftrank des Schleimens",
  "item.minecraft.splash_potion.effect.poison": "Wurfdrang dorr Vorgifdung",
  "item.minecraft.splash_potion.effect.regeneration": "Wurfdrang dorr Regenoration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wurfdrang des sanfdn Falls",
  "item.minecraft.splash_potion.effect.slowness": "Wurfdrang dorr Langsamkeed",
  "item.minecraft.splash_potion.effect.strength": "Wurfdrang dorr Schdärge",
  "item.minecraft.splash_potion.effect.swiftness": "Wurfdrang dorr Schnellischkeed",
  "item.minecraft.splash_potion.effect.thick": "Diggflüss’schorr Wurfdrang",
  "item.minecraft.splash_potion.effect.turtle_master": "Wurfdrang des Schüldgrödnmeisdors",
  "item.minecraft.splash_potion.effect.water": "Wärfbare Wassorrbulle",
  "item.minecraft.splash_potion.effect.water_breathing": "Wurfdrang dorr Undorrwassorradmung",
  "item.minecraft.splash_potion.effect.weakness": "Wurfdrang dorr Schwäsche",
  "item.minecraft.splash_potion.effect.weaving": "Wurftrank des Webens",
  "item.minecraft.splash_potion.effect.wind_charged": "Wurftrank der Windladung",
  "item.minecraft.spruce_boat": "Fischdnhulzbood",
  "item.minecraft.spruce_chest_boat": "Fischdnhulzdruhnbood",
  "item.minecraft.spyglass": "Färnrohr",
  "item.minecraft.squid_spawn_egg": "Dindnfisch-Schborn-Ei",
  "item.minecraft.stick": "Schdogg",
  "item.minecraft.stone_axe": "Schdeenaggsd",
  "item.minecraft.stone_hoe": "Schdeenhagge",
  "item.minecraft.stone_pickaxe": "Schdeenschbiddshagge",
  "item.minecraft.stone_shovel": "Schdeenschibbe",
  "item.minecraft.stone_spear": "Steinspeer",
  "item.minecraft.stone_sword": "Schdeenschwerd",
  "item.minecraft.stray_spawn_egg": "Eiswandororr-Schborn-Ei",
  "item.minecraft.strider_spawn_egg": "Schreidorr-Spawn-Ei",
  "item.minecraft.string": "Foadn",
  "item.minecraft.sugar": "Zuggorr",
  "item.minecraft.suspicious_stew": "Susbeggde Subbe",
  "item.minecraft.sweet_berries": "Süßbeern",
  "item.minecraft.tadpole_bucket": "Gaulquabbnehmorr",
  "item.minecraft.tadpole_spawn_egg": "Gaulquappn-Schborn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeiten-Rüstungsbesatz",
  "item.minecraft.tipped_arrow": "Gedrängdorr Pfeil",
  "item.minecraft.tipped_arrow.effect.awkward": "Gedrängdorr Pfeil",
  "item.minecraft.tipped_arrow.effect.empty": "Nisch herschdellbarorr gedrängdorr Pfeil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pfeil dorr Feuorrresisdenz",
  "item.minecraft.tipped_arrow.effect.harming": "Pfeil des Schadns",
  "item.minecraft.tipped_arrow.effect.healing": "Pfeil dorr Heilung",
  "item.minecraft.tipped_arrow.effect.infested": "Pfeil des Befalls",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pfeil dorr Unsischdbarkeed",
  "item.minecraft.tipped_arrow.effect.leaping": "Pfeil dorr Schbrunggrafd",
  "item.minecraft.tipped_arrow.effect.levitation": "Pfeil dorr Schwebegrafd",
  "item.minecraft.tipped_arrow.effect.luck": "Pfeil des Glüggs",
  "item.minecraft.tipped_arrow.effect.mundane": "Gedrängdorr Pfeil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pfeil dorr Nachdsischd",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfeil des Schleimens",
  "item.minecraft.tipped_arrow.effect.poison": "Pfeil dorr Vorgifdung",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pfeil dorr Regenoration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfeil des sanfdn Falls",
  "item.minecraft.tipped_arrow.effect.slowness": "Pfeil dorr Langsamkeed",
  "item.minecraft.tipped_arrow.effect.strength": "Pfeil dorr Schdärge",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pfeil dorr Schnellischkeed",
  "item.minecraft.tipped_arrow.effect.thick": "Gedrängdorr Pfeil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfeil des Schüldgrödnmeisdors",
  "item.minecraft.tipped_arrow.effect.water": "Nassorr Pfeil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pfeil dorr Undorrwassorradmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Pfeil dorr Schwäsche",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfeil des Webens",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfeil der Windladung",
  "item.minecraft.tnt_minecart": "TNT-Lore",
  "item.minecraft.torchflower_seeds": "Fackelliliensamen",
  "item.minecraft.totem_of_undying": "Dodem dorr Unschderblischkeed",
  "item.minecraft.trader_llama_spawn_egg": "Händlorlama-Schborn-Ei",
  "item.minecraft.trial_key": "Prüfungsschlüssel",
  "item.minecraft.trident": "Dreizagg",
  "item.minecraft.tropical_fish": "Drobnfisch",
  "item.minecraft.tropical_fish_bucket": "Drobnfischehmorr",
  "item.minecraft.tropical_fish_spawn_egg": "Drobnfisch-Schborn-Ei",
  "item.minecraft.turtle_helmet": "Schüldgrödnbanzor",
  "item.minecraft.turtle_scute": "Schildkröten-Hornschild",
  "item.minecraft.turtle_spawn_egg": "Schüldgrödn-Schborn-Ei",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plagegeister-Rüstungsbesatz",
  "item.minecraft.vex_spawn_egg": "Blagegeisdorr-Schborn-Ei",
  "item.minecraft.villager_spawn_egg": "Dorfbewohnorr-Schborn-Ei",
  "item.minecraft.vindicator_spawn_egg": "Dienorr-Schborn-Ei",
  "item.minecraft.wandering_trader_spawn_egg": "Fahrendorr-Händlorr-Schborn-Ei",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Warthof-Rüstungsbesatz",
  "item.minecraft.warden_spawn_egg": "Wärdorr-Schborn-Ei",
  "item.minecraft.warped_fungus_on_a_stick": "Würrbilzrude",
  "item.minecraft.water_bucket": "Wassorrehmorr",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wegfinder-Rüstungsbesatz",
  "item.minecraft.wheat": "Weidsn",
  "item.minecraft.wheat_seeds": "Weidsngörnor",
  "item.minecraft.white_bundle": "Weißes Bündel",
  "item.minecraft.white_dye": "Weeßorr Farbschdoff",
  "item.minecraft.white_harness": "Weißes Geschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wildnis-Rüstungsbesatz",
  "item.minecraft.wind_charge": "Windkugel",
  "item.minecraft.witch_spawn_egg": "Heggsn-Schborn-Ei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherschgeledd-Schborn-Ei",
  "item.minecraft.wither_spawn_egg": "Wither-Schborn-Ei",
  "item.minecraft.wolf_armor": "Wolfspanzer",
  "item.minecraft.wolf_spawn_egg": "Wulfs-Schborn-Ei",
  "item.minecraft.wooden_axe": "Hulzaggsd",
  "item.minecraft.wooden_hoe": "Hulzhagge",
  "item.minecraft.wooden_pickaxe": "Hulzschbiddshagge",
  "item.minecraft.wooden_shovel": "Hulzschibbe",
  "item.minecraft.wooden_spear": "Holzspeer",
  "item.minecraft.wooden_sword": "Hulzschwerd",
  "item.minecraft.writable_book": "Schwahrde un Fädorr",
  "item.minecraft.written_book": "Beschriebne Schwahrde",
  "item.minecraft.yellow_bundle": "Gelbes Bündel",
  "item.minecraft.yellow_dye": "Gelborr Farbschdoff",
  "item.minecraft.yellow_harness": "Gelbes Geschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Schborn-Ei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiefärde-Schborn-Ei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilus-Spawn-Ei",
  "item.minecraft.zombie_spawn_egg": "Zombie-Schborn-Ei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorfbewohnorr-Schborn-Ei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizierdorr-Piglin-Schborn-Ei"
}
export const sxu = items; 
